<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="text" max-width="250" class="mb-1"></v-skeleton-loader>
      <v-skeleton-loader type="text" max-width="350" class="mb-3"></v-skeleton-loader>
      <v-row>
        <v-col cols="12" sm="2" md="2" lg="2" v-for="i in 6" :key="i">
          <v-skeleton-loader type="list-item"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" v-for="i in 4" :key="i">
          <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6" v-for="i in 2" :key="i">
          <v-card elevation="2" class="px-3 py-3">
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Detalhes da oportunidade
      </div>
      <div class="text">
        Clique nas abas abaixo para ver os detalhes da oportunidade
      </div>
      <etapas-oportunidade
        v-if="oportunidade.opu_status !== 2"
        :uuidOportunidade="oportunidade.uuid_opu_id"
        :status="oportunidade.opu_status"
        :etapasAtuais="oportunidade.etapas"
      >
      </etapas-oportunidade>
      <v-row class="my-2">
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-card class="py-3 px-4 h-100">
            <div class="text-h1 mb-2">Status</div>
            <v-chip label :color="oportunidade.opu_status === 1 ? 'blue' : oportunidade.opu_status === 2 ? 'red' : 'warning'" text-color="white">
              {{oportunidade.opu_status === 1 ? `Em aberto ${moment(oportunidade.opu_criado_em).fromNow()}` : null}}
              {{oportunidade.opu_status === 2 ? 'Perdido' : null}}
              {{oportunidade.opu_status === 3 ? 'Fechado' : null}}
            </v-chip>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-card class="py-3 px-4 h-100">
            <div class="text-h1 mb-2">Contato</div>
            <div class="text-h2 cursor-pointer" @click="goToContato(oportunidade.cliente.uuid_cli_id)">
              {{oportunidade.cliente.cli_nome}}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="ml-1 mb-1">
                    info
                  </v-icon>
                </template>
                <span>Visualizar contato</span>
              </v-tooltip>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-card class="py-3 px-4 h-100">
            <div class="text-h1 mb-2">Dono da oportunidade</div>
            <div class="text-h2">
              {{oportunidade.usuario.usu_nome}}
            </div>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="3" md="3" lg="3">
          <v-card class="py-3 px-4 h-100">
            <div class="text-h1 mb-2">Tipo da oportunidade</div>
            <div class="text-h2">
              Sistema Fotovoltaico
            </div>
          </v-card>
        </v-col> -->
      </v-row>
      <v-tabs
        next-icon="chevron_right"
        prev-icon="chevron_left"
        show-arrows
        class="ui-tabs"
        v-model="tabs">
        <v-tab link to="#detalhes-do-negocio">
          <v-icon>info</v-icon> Detalhes da oportunidade
        </v-tab>
        <v-tab link to="#contas-de-energia" @click="getContasEnergia()" :disabled="carregando">
          <v-icon>lightbulb</v-icon> Contas de energia
        </v-tab>
        <v-tab link to="#dimensionamento" @click="getDadosSistema()" :disabled="loadingExatoDimensionamento || loadingSistemaSugerido">
          <v-icon>wb_sunny</v-icon> Dimensionamento
        </v-tab>
        <v-tab link to="#propostas-comerciais" @click="getPropostasComerciais()" :disabled="loadingPropostas || loadingExatoDimensionamento">
          <v-icon>request_quote</v-icon> Propostas comerciais
        </v-tab>
        <v-tab link to="#atividades" @click="getTarefas()" :disabled="loadingTarefas">
          <v-icon>fact_check</v-icon> Atividades
        </v-tab>
        <v-tab link to="#anexos" @click="getAnexos()" :disabled="loadingAnexos">
          <v-icon>attach_file</v-icon> Anexos
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item class="px-1 pb-1" id="detalhes-do-negocio">
          <v-card class="px-3">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6">
                <div class="text-center text-h2 my-3">
                  Detalhes gerais
                </div>
                <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Criado em:
                          </b>
                        </td>
                        <td class="text ui-capitalize-initial">
                          {{$root.Formatter.formatDate(oportunidade.opu_criado_em, 'dddd, LLL')}}
                        </td>
                      </tr>
                      <tr v-if="oportunidade.opu_adiamento_data">
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Adiado para:
                          </b>
                        </td>
                        <td class="text ui-capitalize-initial">
                          {{$root.Formatter.formatDate(oportunidade.opu_adiamento_data, 'dddd, LL')}}
                        </td>
                      </tr>
                      <tr v-if="oportunidade.opu_adiamento_descricao">
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Motivo do adiamento:
                          </b>
                        </td>
                        <td class="text" v-html="oportunidade.opu_adiamento_descricao">
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Chance de fechar a oportunidade:
                          </b>
                        </td>
                        <td class="text">
                          <v-chip text-color="white" label :color="(chances.filter(item => item.value === oportunidade.opu_probabilidade))[0].cor">{{(chances.filter(item => item.value === oportunidade.opu_probabilidade))[0].text}}</v-chip>
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Tipo de instalação:
                          </b>
                        </td>
                        <td class="text">
                          {{(tiposInstalacao.filter(item => item.value === oportunidade.opu_tipo_instalacao))[0].text}}
                        </td>
                      </tr>
                      <tr v-if="tiposEstrutura && tiposEstrutura.length > 0">
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Tipo da estrutura:
                          </b>
                        </td>
                        <td class="text">
                          {{(tiposEstrutura.filter(item => item.value === oportunidade.opu_tipo_estrutura))[0].text}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Descrição:
                          </b>
                        </td>
                        <td class="text">
                          <p class="mt-2" v-if="oportunidade.opu_observacao" v-html="oportunidade.opu_observacao">
                          </p>
                          <p class="mt-2" v-else>-</p>
                        </td>
                      </tr>
                      <tr v-if="oportunidade.opu_status === 2">
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Motivo da perda:
                          </b>
                        </td>
                        <td class="text">
                          <p class="mt-2">
                            {{(motivosPerda.filter(item => item.value === oportunidade.opu_perda_motivo))[0].text}}
                          </p>
                        </td>
                      </tr>
                      <tr v-if="oportunidade.opu_status === 2">
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Descrição da perda:
                          </b>
                        </td>
                        <td class="text">
                          <p class="mt-2" v-html="oportunidade.opu_perda_descricao">
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row no-gutters class="mt-3">
                  <v-btn
                    color="warning"
                    v-if="oportunidade.opu_status !== 2"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="openDialogAdiar()"
                  >
                    Adiar oportunidade
                  </v-btn>
                  <v-btn
                    v-if="oportunidade.opu_status !== 2"
                    class="ml-2"
                    color="error"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="openDialogPerda()"
                  >
                    Marcar como perdido
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="ml-2"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="openDialogDetalhes()"
                  >
                    Alterar detalhes
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <div class="text-center text-h2 my-3">
                  Endereço da oportunidade
                </div>
                <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Logradouro:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_rua ? oportunidade.opu_rua : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Número:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_numero ? oportunidade.opu_numero : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Complemento:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_complemento ? oportunidade.opu_complemento : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Bairro:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_bairro ? oportunidade.opu_bairro : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            CEP:
                          </b>
                        </td>
                        <td class="text" v-if="oportunidade.opu_cep">
                          {{oportunidade.opu_cep | vMask('#####-###')}}
                        </td>
                        <td class="text" v-else>-</td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Estado:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_uf ? oportunidade.opu_uf : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Cidade:
                          </b>
                        </td>
                        <td class="text">
                           {{oportunidade.opu_cidade ? oportunidade.opu_cidade : '-'}}
                        </td>
                      </tr>
                      <tr>
                        <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                          <b>
                            Distância de ida e volta:
                          </b>
                        </td>
                        <td class="text">
                          {{oportunidade.opu_distancia ? oportunidade.opu_distancia + 'km' : '-'}}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-btn
                  class="mt-3 mb-1"
                  color="primary"
                  :loading="salvando"
                  :disabled="salvando"
                  @click="openDialogEndereco()"
                >
                  Alterar endereço
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-dialog
            v-model="dialogAdiar"
            persistent
            max-width="400px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  Adiar oportunidade
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogAdiar()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formAdiar">
                <v-menu
                  ref="calendarDataAdiar"
                  v-model="calendarDataAdiar"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      label="Deseja adiar para qual data?*"
                      :rules="[rules.required]"
                      append-icon="calendar_today"
                      :loading="salvando"
                      :disabled="salvando"
                      v-bind="attrs"
                      v-on="on"
                      v-model="dataFormatadaAdiar"
                      v-mask="'##/##/####'"
                      @input="() => {
                        calendarDataAdiar = false
                        adiar.opu_adiamento_data = $root.Formatter.parseDate(dataFormatadaAdiar)
                        updatePickerModalDataAdiar = $root.Formatter.parseDate(dataFormatadaAdiar)
                      }"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :picker-date.sync="updatePickerModalDataAdiar"
                    year-icon="calendar_today"
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    :loading="salvando"
                    :disabled="salvando"
                    v-model="dataAdiar"
                  ></v-date-picker>
                </v-menu>
                <v-textarea
                  outlined
                  rows="3"
                  v-model="adiar.opu_adiamento_descricao"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Descreva o motivo do adiamento*"
                ></v-textarea>
              </v-form>
              <v-divider></v-divider>
              <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="closeDialogAdiar()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="saveAdiar()"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Salvar
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogPerda"
            persistent
            max-width="400px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  A oportunidade foi perdido?
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogPerda()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formPerda">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="perda.opu_perda_motivo"
                  :items="motivosPerda"
                  :rules="[rules.required]"
                  clearable
                  clear-icon="close"
                  label="Motivo da perda*"
                  append-icon="expand_more"
                  :loading="salvando"
                  :disabled="salvando"
                  outlined
                >
                </v-autocomplete>
                <v-textarea
                  outlined
                  rows="3"
                  v-model="perda.opu_perda_descricao"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Descreva o motivo da perda*"
                ></v-textarea>
              </v-form>
              <v-divider></v-divider>
              <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="closeDialogPerda()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="savePerda()"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Salvar
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogDetalhes"
            persistent
            max-width="500px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  Alterar detalhes
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogDetalhes()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formDetalhes">
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="detalhes.opu_tipo_instalacao"
                      :items="tiposInstalacao"
                      :rules="[rules.required]"
                      clearable
                      clear-icon="close"
                      label="Tipos de instalação*"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="detalhes.opu_probabilidade"
                      :items="chances"
                      :rules="[rules.required]"
                      clearable
                      clear-icon="close"
                      label="Chance de fechar?*"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                    <v-autocomplete
                      :menu-props="{ offsetY: true}"
                      v-model="detalhes.opu_tipo_estrutura"
                      :items="tiposEstrutura"
                      :rules="[rules.required]"
                      clearable
                      clear-icon="close"
                      label="Tipo da estrutura*"
                      append-icon="expand_more"
                      :loading="salvando"
                      :disabled="salvando"
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                    <v-textarea
                      outlined
                      rows="6"
                      counter
                      :rules="[rules.required, rules.max]"
                      v-model="detalhes.opu_observacao"
                      :loading="salvando"
                      :disabled="salvando"
                      label="Descreva a nova oportunidade*"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
              <v-divider></v-divider>
              <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="closeDialogDetalhes()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="saveDetalhes()"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Salvar
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="contas-de-energia">
          <v-card class="px-3 pb-3">
            <v-row no-gutters align="center" justify="space-between" class="my-3">
              <div class="text-center text-h2">
                Contas de energia
              </div>
              <v-btn
                color="primary"
                class="mt-2"
                @click="dialogContas = true"
                :loading="salvando || carregando"
                :disabled="salvando || carregando"
              >
                Adicionar conta
              </v-btn>
            </v-row>
            <v-data-table
              :headers="headersContasEnergia"
              :items="dadosContasEnergia"
              loading-text="Carregando... Por favor aguarde"
              :loading="carregando"
              class="elevation-1 base_table mt-4"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:item.opc_modalidade_tarifaria="{ item }">
                {{retornaModalidade(item.opc_modalidade_tarifaria)}}
              </template>
              <template v-slot:item.opc_entrada_padrao="{ item }">
                {{retornaEntrada(item.opc_entrada_padrao)}}
              </template>
              <template v-slot:item.opc_valor_kwh="{ item }">
                {{$root.Formatter.floatToMoney(item.opc_valor_kwh)}}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="center" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialogContasInfo(item)" color="primary" class="mr-2">
                        electrical_services
                      </v-icon>
                    </template>
                    <span>Consumo mês a mês</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialogContas(item)" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteConta(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
          <v-dialog
            v-model="dialogContas"
            persistent
            max-width="800px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  {{conta.id ? 'Editar' : 'Nova'}} conta de energia
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogContas()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formContas">
                <v-row>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-autocomplete
                  v-model="conta.opc_modalidade_tarifaria"
                  autocomplete="off"
                  :items="modalidades"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Modalidade tarifária*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-autocomplete
                  v-model="conta.opc_entrada_padrao"
                  autocomplete="off"
                  :items="padroes"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Padrão de entrada*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  v-model="conta.opc_unidade_consumidora"
                  label="Código da unidade consumidora"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="conta.opc_unidade_consumidora_descricao"
                  :rules="[rules.required]"
                  label="Unidade consumidora*"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0">
                <v-text-field-percent
                  label="Consumo médio (kWh)*"
                  outlined
                  v-model="conta.opc_consumo_mensal"
                  v-bind:properties="{
                    readonly: false,
                    hideDetails: true,
                    outlined: true,
                    disabled: salvando,
                    loading: salvando,
                    rules: [rules.required]
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 12,
                    precision: 2,
                    empty: '',
                  }"
                ></v-text-field-percent>
              </v-col>
              <v-col cols="12" sm="12" md="1" lg="1" xl="1" class="pt-0 pl-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" class="ui-btn-clean py-2 w-100 px-0" v-bind="attrs" v-on="on" @click="openDialogContasInfo()">
                      <v-icon>list_alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Calcular consumo</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0">
                <v-text-field-percent
                  label="Consumo mínimo (kWh)*"
                  outlined
                  v-model="conta.opc_consumo_minimo"
                  v-bind:properties="{
                    readonly: false,
                    hideDetails: true,
                    outlined: true,
                    disabled: salvando,
                    loading: salvando,
                    rules: [rules.required]
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 12,
                    precision: 2,
                    empty: '',
                  }"
                ></v-text-field-percent>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0">
                <vuetify-money
                  lazy-validation
                  v-model="conta.opc_valor_kwh"
                  :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                  :disabled="salvando"
                  :loading="salvando"
                  outlined
                  :options="optionsMoney"
                  valueWhenIsEmpty=""
                  :rules="[rules.required]"
                  label="Preço do kWh do contato*"
                ></vuetify-money>
              </v-col>
                </v-row>
              </v-form>
              <v-divider></v-divider>
              <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="closeDialogContas()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="saveEditConta()"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Salvar
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDeleteConta" max-width="400">
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  Remover Conta
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="dialogDeleteConta = false">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <div class="text-h3 mb-5">
                Tem certeza que deseja remover esta conta?
              </div>
              <v-divider class="mb-3"></v-divider>
              <v-row
                align="center"
                justify="space-between"
                class="px-5 py-5"
              >
                <v-btn
                  color="cancel"
                  :loading="salvando"
                  :disabled="salvando"
                  @click="dialogDeleteConta = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="success"
                  :loading="salvando"
                  :disabled="salvando"
                  @click="removeConta()"
                >
                  Remover
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogContaInfo"
            persistent
            max-width="1000px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  Alterar consumo mês a mês
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogConsumo()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formConsumo">
                <v-row class="mb-2">
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      autofocus
                      label="Janeiro"
                      outlined
                      @change="atualizaCamposConsumo(conta.opc_consumo_jan)"
                      v-model="conta.opc_consumo_jan"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Fevereiro"
                      outlined
                      v-model="conta.opc_consumo_fev"
                      @change="atualizaCamposConsumo(conta.opc_consumo_fev)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Março"
                      outlined
                      v-model="conta.opc_consumo_mar"
                      @change="atualizaCamposConsumo(conta.opc_consumo_mar)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Abril"
                      outlined
                      v-model="conta.opc_consumo_abr"
                      @change="atualizaCamposConsumo(conta.opc_consumo_abr)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Maio"
                      outlined
                      v-model="conta.opc_consumo_mai"
                      @change="atualizaCamposConsumo(conta.opc_consumo_mai)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Junho"
                      outlined
                      v-model="conta.opc_consumo_jun"
                      @change="atualizaCamposConsumo(conta.opc_consumo_jun)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Julho"
                      outlined
                      v-model="conta.opc_consumo_jul"
                      @change="atualizaCamposConsumo(conta.opc_consumo_jul)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Agosto"
                      outlined
                      v-model="conta.opc_consumo_ago"
                      @change="atualizaCamposConsumo(conta.opc_consumo_ago)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Setembro"
                      outlined
                      v-model="conta.opc_consumo_set"
                      @change="atualizaCamposConsumo(conta.opc_consumo_set)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Outubro"
                      outlined
                      v-model="conta.opc_consumo_out"
                      @change="atualizaCamposConsumo(conta.opc_consumo_out)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Novembro"
                      outlined
                      v-model="conta.opc_consumo_nov"
                      @change="atualizaCamposConsumo(conta.opc_consumo_nov)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2">
                    <v-text-field-percent
                      label="Dezembro"
                      outlined
                      v-model="conta.opc_consumo_dez"
                      @change="atualizaCamposConsumo(conta.opc_consumo_dez)"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        outlined: true,
                        disabled: salvando,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                    <v-text-field-percent
                      label="Consumo médio (kWh)"
                      outlined
                      v-model="conta.opc_consumo_mensal"
                      v-bind:properties="{
                        readonly: false,
                        hideDetails: true,
                        disabled: salvando,
                        outlined: true,
                        loading: salvando
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 12,
                        precision: 2,
                        empty: '',
                      }"
                    ></v-text-field-percent>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                  <v-btn
                    color="cancel"
                    @click="closeDialogConsumo()"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="saveEditConta('consumo')"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    Salvar
                  </v-btn>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="dimensionamento">
          <v-card class="px-3">
            <v-tabs
              next-icon="chevron_right"
              prev-icon="chevron_left"
              show-arrows
              class="ui-tabs ui-tabs-big"
              centered
              v-model="tabsDimensionamento">
              <v-tab>
                <div class="text-center">
                  <v-icon large>query_stats</v-icon><br>
                  Informe as entradas
                </div>
              </v-tab>
              <v-tab @click="getDadosSistema()" :disabled="loadingExatoDimensionamento || loadingSistemaSugerido">
                <div class="text-center">
                  <v-icon large>solar_power</v-icon><br>
                  Defina o sistema
                </div>
              </v-tab>
              <v-tab>
                <div class="text-center" @click="getDadosGeracao()" :disabled="loadingGraficoGeracao || loadingTabelaGeracao">
                  <v-icon large>verified</v-icon><br>
                  Valide a geração
                </div>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabsDimensionamento">
              <v-tab-item class="px-1 pb-1">
                <v-card class="px-3 py-3">
                  <div class="text-center text-h2 my-3">
                    Entradas para o dimensionamento
                    <br>
                    <div class="text">
                      Os dados abaixo serão usados para o dimensionamento do sistema
                    </div>
                  </div>
                  <v-simple-table :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Cidade
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_cidade ? oportunidade.opu_cidade + '/' : ''}}{{oportunidade.opu_uf ? oportunidade.opu_uf : ''}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogEndereco()">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Irradiação solar diária (Média Anual)
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_irradiacao_diaria ? oportunidade.opu_irradiacao_diaria : '-'}}
                            <!-- <v-chip color="success" label small class="ml-2 mb-1" @click="dialogGrafico = true">
                              <v-icon color="white" small>bar_chart</v-icon>
                            </v-chip> -->
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('irradiacao')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <tr v-if="tiposEstrutura && tiposEstrutura.length > 0">
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Tipo da estrutura
                            </b>
                          </td>
                          <td class="text">
                            {{(tiposEstrutura.filter(item => item.value === oportunidade.opu_tipo_estrutura))[0].text}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('estrutura')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Potência do módulo
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_potencia_modulo ? oportunidade.opu_potencia_modulo : '-'}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('potencia_modulo')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Área útil utilizada para cada módulo
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_area_modulo ? oportunidade.opu_area_modulo : '-'}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('area')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Percentual de perda
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_percentual_perda ? oportunidade.opu_percentual_perda + '%' : '-'}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('perda')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                        <!-- <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Simultaneidade (percentual de consumo instantâneo)
                            </b>
                          </td>
                          <td class="text">
                            {{entradas.simultaneidade}}%?
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('simultaneidade')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr> -->
                        <!-- <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Data do início de operação do sistema
                            </b>
                          </td>
                          <td class="text">
                            {{entradas.data}}?
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('data')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr> -->
                        <tr>
                          <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="50%">
                            <b>
                              Potência desejada
                            </b>
                          </td>
                          <td class="text">
                            {{oportunidade.opu_potencia_desejada ? oportunidade.opu_potencia_desejada + ' (kWp)' : '-'}}
                            <v-chip color="primary" label small class="ml-2 mb-1" @click="openDialogTipoEstrutura('potencia_desejada')">
                              <v-icon color="white" small>edit</v-icon>
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-dialog
                  v-model="dialogTipoEstrutura"
                  persistent
                  max-width="400px"
                >
                  <v-card class="ui-dialog-top">
                    <v-row align="center" justify="space-between">
                      <v-col cols="10">
                        Alterar
                        {{tipoEstrutura === 'estrutura' ? 'tipo da estrutura' : ''}}
                        {{tipoEstrutura === 'irradiacao' ? 'irradiação solar diária' : ''}}
                        {{tipoEstrutura === 'potencia_modulo' ? 'potência do módulo' : ''}}
                        {{tipoEstrutura === 'area' ? 'área útil de cada módulo' : ''}}
                        {{tipoEstrutura === 'perda' ? 'percentual de perda' : ''}}
                        {{tipoEstrutura === 'simultaneidade' ? 'percentual de consumo simultâneo' : ''}}
                        {{tipoEstrutura === 'data' ? 'data' : ''}}
                        {{tipoEstrutura === 'potencia_desejada' ? 'dimensionamento desejado' : ''}}
                      </v-col>
                      <v-col cols="2" class="text-right">
                        <v-icon @click="closeDialogTipoEstrutura()">close</v-icon>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card class="ui-dialog-content">
                    <v-form ref="formTipoEstrutura">
                      <v-autocomplete
                        v-if="tipoEstrutura === 'estrutura'"
                        :menu-props="{ offsetY: true}"
                        v-model="entradas.opu_tipo_estrutura"
                        :items="tiposEstrutura"
                        :rules="[rules.required]"
                        clearable
                        clear-icon="close"
                        label="Tipo da estrutura*"
                        append-icon="expand_more"
                        :loading="salvando"
                        :disabled="salvando"
                        outlined
                      >
                      </v-autocomplete>
                      <v-text-field-percent
                        label="Potência do módulo*"
                        outlined
                        v-if="tipoEstrutura === 'potencia_modulo'"
                        v-model="entradas.opu_potencia_modulo"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando,
                          rules:[rules.required]
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                      <v-text-field-percent
                        v-if="tipoEstrutura === 'area'"
                        v-model="entradas.opu_area_modulo"
                        label="Área útil de cada módulo*"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          rules: [rules.required],
                          loading: salvando
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                      <v-text-field-percent
                        v-if="tipoEstrutura === 'perda'"
                        :rules="[rules.required]"
                        label="Perda (%)*"
                        outlined
                        v-model="entradas.opu_percentual_perda"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                      <v-text-field-percent
                        v-if="tipoEstrutura === 'simultaneidade'"
                        :rules="[rules.required]"
                        label="Percentual de consumo simultâneo*"
                        outlined
                        v-model="entradas.simultaneidade"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                      <v-menu
                        v-if="tipoEstrutura === 'data'"
                        ref="calendarDataEntrada"
                        v-model="calendarDataEntrada"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            label="Informe a nova data*"
                            :rules="[rules.required]"
                            append-icon="calendar_today"
                            :loading="salvando"
                            :disabled="salvando"
                            v-bind="attrs"
                            v-on="on"
                            v-model="dataFormatadaEntrada"
                            v-mask="'##/##/####'"
                            @input="() => {
                              calendarDataEntrada = false
                              entradas.data = $root.Formatter.parseDate(dataFormatadaEntrada)
                              updatePickerModalDataEntrada = $root.Formatter.parseDate(dataFormatadaEntrada)
                            }"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :picker-date.sync="updatePickerModalDataEntrada"
                          year-icon="calendar_today"
                          prev-icon="chevron_left"
                          next-icon="chevron_right"
                          :loading="salvando"
                          :disabled="salvando"
                          v-model="dataEntrada"
                        ></v-date-picker>
                      </v-menu>
                      <v-text-field-percent
                        v-if="tipoEstrutura === 'irradiacao'"
                        label="Irradiação solar diária*"
                        outlined
                        v-model="entradas.opu_irradiacao_diaria"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          disabled: salvando,
                          outlined: true,
                          rules: [rules.required],
                          loading: salvando
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                      <!-- <v-radio-group v-model="entradas.potencia_desejada_tipo" v-if="tipoEstrutura === 'potencia_desejada'">
                        <v-radio
                          v-for="(item, index) in tiposPotencia"
                          :key="index"
                          on-icon="radio_button_checked"
                          off-icon="radio_button_unchecked"
                          :label="item.text"
                          :value="item.value"
                        ></v-radio>
                      </v-radio-group> -->
                      <v-text-field-percent
                        v-if="tipoEstrutura === 'potencia_desejada'"
                        label="Potência desejada (kWp)*"
                        outlined
                        v-model="entradas.opu_potencia_desejada"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando,
                          rules:[rules.required]
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                    </v-form>
                    <v-divider class="mt-3"></v-divider>
                    <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                      <v-btn
                        color="cancel"
                        :disabled="salvando"
                        :loading="salvando"
                        @click="closeDialogTipoEstrutura()"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="editTipoEstrutura()"
                        :loading="salvando"
                        :disabled="salvando"
                      >
                        Salvar
                      </v-btn>
                    </v-row>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="dialogGrafico"
                  persistent
                  max-width="1000px"
                >
                  <v-card class="ui-dialog-top">
                    <v-row align="center" justify="space-between">
                      <v-col cols="10">
                        Irradiação solar diária (Média Anual)
                      </v-col>
                      <v-col cols="2" class="text-right">
                        <v-icon @click="dialogGrafico = false">close</v-icon>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card class="ui-dialog-content">
                    <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th colspan="13" class="text-center">
                              <strong>Irradiação solar diária média mensal [kWh/m2.dia]</strong>
                            </th>
                          </tr>
                          <tr>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Anual</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Jan</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Fev</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Mar</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Abr</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Mai</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Jun</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Jul</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Ago</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Set</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Out</th>
                            <th :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">Nov</th>
                            <th>Dez</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,81 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">5,40 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">5,35 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">5,39 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,86 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,06 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">3,62 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">3,93 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,73 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,42 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">4,93 </td>
                            <td :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">5,53 </td>
                            <td>5,49 </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-card class="px-2 py-2 my-2" elevation="2">
                      <line-chart :options="optionsChartIrradiacao" :height="150" :data="chartDataIrradiacao"></line-chart>
                    </v-card>
                    <v-card class="px-2 py-2 mt-2" elevation="2">
                      <div class="text text--thin">
                        Fonte: Atlas Brasileiro de Energia Solar (2017) - LABREN / CCST / INPE (Instituto Nacional de Pesquisas Espaciais) <br />
                        Plano inclinado com ângulo igual a latitude e orientação norte.
                      </div>
                    </v-card>
                    <v-divider></v-divider>
                    <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                      <v-btn
                        color="cancel"
                        :disabled="salvando"
                        :loading="salvando"
                        @click="dialogGrafico = false"
                      >
                        Fechar
                      </v-btn>
                    </v-row>
                  </v-card>
                </v-dialog>
              </v-tab-item>
              <v-tab-item class="px-1 pb-1">
                <v-card class="px-3">
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <div class="text-center text-h2 my-3">
                        Resultado exato do Dimensionamento
                      </div>
                      <div v-if="loadingExatoDimensionamento">
                        <v-card elevation="2" class="px-3 py-3">
                          <v-skeleton-loader type="table"></v-skeleton-loader>
                        </v-card>
                      </div>
                      <div v-else>
                        <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Potência
                                  </b>
                                </td>
                                <td class="text">
                                  {{exatoDimensionamentoDados.dim_potencia ? exatoDimensionamentoDados.dim_potencia + ' kWp' : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Energia a ser gerada (média anual)
                                  </b>
                                </td>
                                <td class="text">
                                  {{exatoDimensionamentoDados.dim_energia_gerar ? exatoDimensionamentoDados.dim_energia_gerar + ' kWh/mês' : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Potência do módulo
                                  </b>
                                </td>
                                <td class="text">
                                  {{exatoDimensionamentoDados.dim_potencia_modulo ? exatoDimensionamentoDados.dim_potencia_modulo + ' Wp' : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Quantidade de módulos
                                  </b>
                                </td>
                                <td class="text">
                                  {{exatoDimensionamentoDados.dim_quantidade_modulos ? exatoDimensionamentoDados.dim_quantidade_modulos : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Área útil necessária (estimada)
                                  </b>
                                </td>
                                <td class="text">
                                  {{exatoDimensionamentoDados.dim_area_util ? exatoDimensionamentoDados.dim_area_util + ' m²' : '-'}}
                                </td>
                              </tr>
                              <tr v-if="tiposEstrutura && tiposEstrutura.length > 0">
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Tipo da estrutura:
                                  </b>
                                </td>
                                <td class="text" v-if="exatoDimensionamentoDados.dim_tipo_estrutura">
                                  {{(tiposEstrutura.filter(item => item.value === exatoDimensionamentoDados.dim_tipo_estrutura))[0].text}}
                                </td>
                                <td v-else class="text">
                                  -
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <div class="text-center text-h2 my-3">
                        Sistema sugerido (a ser orçado)
                      </div>
                      <div v-if="loadingSistemaSugerido">
                        <v-card elevation="2" class="px-3 py-3">
                          <v-skeleton-loader type="table"></v-skeleton-loader>
                        </v-card>
                      </div>
                      <div v-else>
                        <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                          <template v-slot:default>
                            <tbody>
                              <tr style="background-color: rgba(135,203,22,.2);">
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Potência
                                  </b>
                                </td>
                                <td class="text">
                                  {{sistemaSugeridoDados.dim_potencia ? sistemaSugeridoDados.dim_potencia + ' kWp' : '-'}}
                                </td>
                              </tr>
                              <tr style="background-color: rgba(135,203,22,.2);">
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Energia a ser gerada (média anual)
                                  </b>
                                </td>
                                <td class="text">
                                  {{sistemaSugeridoDados.dim_energia_gerar ? sistemaSugeridoDados.dim_energia_gerar + ' kWh/mês' : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Potência do módulo
                                  </b>
                                </td>
                                <td class="text">
                                  {{sistemaSugeridoDados.dim_potencia_modulo ? sistemaSugeridoDados.dim_potencia_modulo + ' Wp' : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Quantidade de módulos
                                  </b>
                                </td>
                                <td class="text">
                                  {{sistemaSugeridoDados.dim_quantidade_modulos ? sistemaSugeridoDados.dim_quantidade_modulos : '-'}}
                                </td>
                              </tr>
                              <tr>
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Área útil necessária (estimada)
                                  </b>
                                </td>
                                <td class="text">
                                  {{sistemaSugeridoDados.dim_area_util ? sistemaSugeridoDados.dim_area_util + ' m²' : '-'}}
                                </td>
                              </tr>
                              <tr v-if="tiposEstrutura && tiposEstrutura.length > 0">
                                <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="70%">
                                  <b>
                                    Tipo da estrutura:
                                  </b>
                                </td>
                                <td class="text" v-if="sistemaSugeridoDados.dim_tipo_estrutura">
                                  {{(tiposEstrutura.filter(item => item.value === sistemaSugeridoDados.dim_tipo_estrutura))[0].text}}
                                </td>
                                <td v-else class="text">
                                  -
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-alert
                          class="mt-4"
                          dense
                          icon="info"
                          type="warning"
                        >
                          Importante: Deixe o sistema sugerido com as mesmas características do kit que será orçado.
                        </v-alert>
                        <v-btn
                          class="mt-3 mb-1"
                          color="primary"
                          @click="abrirNovaProposta()"
                          :loading="salvando"
                          :disabled="salvando"
                        >
                          Gerar nova proposta
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item class="px-1 pb-3">
                <v-card class="px-3 pt-2 pb-3">
                  <div class="text-center text-h2 my-3">
                    Estimativa de geração de energia mês a mês para o sistema sugerido
                    <br>
                    <div class="text">
                      Média anual: {{dadosGraficoGeracao.media_geracao_anula}} kWh/mês
                    </div>
                  </div>
                  <div v-if="loadingGraficoGeracao">
                    <v-card elevation="2" class="px-3 py-16 text-center">
                      <v-progress-circular
                        :size="100"
                        :width="10"
                        indeterminate
                      ></v-progress-circular>
                    </v-card>
                  </div>
                  <div v-else>
                    <bar-chart :options="barChartOptions" :height="100" :data="dadosGraficoGeracaoData"></bar-chart>
                  </div>
                  <v-row no-gutters align="center" justify="center">
                    <v-alert
                      class="mt-5 fit-content"
                      dense
                      icon="info"
                      type="warning"
                    >
                      Na tabela abaixo, você poderá analisar a estimativa de economia gerada pelo sistema proposto.
                    </v-alert>
                  </v-row>
                  <div class="text-center text-h2 my-3">
                    Unidade consumidora
                    <br>
                    <div class="text">
                      Ficará com 100% do crédito gerado <br>
                      <b class="mt-3">
                        * Valores estimados (não considerado possíveis cobranças de ICMS sobra a TUSD)
                      </b>
                    </div>
                  </div>
                  <v-data-table
                    :loading="loadingTabelaGeracao"
                    :headers="headerUnidadePrincipal"
                    :items="dadosUnidadePrincipal"
                    loading-text="Carregando... Por favor aguarde"
                    class="elevation-1 base_table mt-1"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    :header-props="{
                      sortIcon: 'north',
                    }"
                  >
                  </v-data-table>
                  <!-- no watch tem a função que faz o get das informações quando clica em um dos itens para expandir
                  assim você pode atualizar os dados da tabela a partir deste local -->
                  <!-- <v-data-table
                    loading-text="Carregando... Por favor aguarde"
                    :loading="loadingTabelaGeracao"
                    :headers="headerUnidadePrincipal"
                    :items="dadosUnidadePrincipal"
                    :single-expand="true"
                    :expanded.sync="expanded"
                    expand-icon="expand_more"
                    item-key="id"
                    show-expand
                    @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
                    class="elevation-1 base_table click_row"
                    :footer-props="{
                      itemsPerPageOptions: [5,10,15,20,25,50,100],
                      showFirstLastPage: true,
                      firstIcon: 'skip_previous',
                      lastIcon: 'skip_next',
                      prevIcon: 'chevron_left',
                      nextIcon: 'chevron_right'
                    }"
                    :header-props="{
                      sortIcon: 'north',
                    }"
                  >
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-card class="py-2 px-2 my-3" elevation="2">
                          <v-simple-table :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    Mês do ano
                                  </th>
                                  <th class="text-left">
                                    Mês de geração
                                  </th>
                                  <th class="text-left">
                                    Tarifa (R$)
                                  </th>
                                  <th class="text-left">
                                    Fio B (R$)
                                  </th>
                                  <th class="text-left">
                                    Geração (kWh)
                                  </th>
                                  <th class="text-left">
                                    Consumo total (kWh)
                                  </th>
                                  <th class="text-left">
                                    Consumo simultâneo (kWh)
                                  </th>
                                  <th class="text-left">
                                    Fatura sem solar (R$)
                                  </th>
                                  <th class="text-left">
                                    Fatura com solar (R$)
                                  </th>
                                  <th class="text-left">
                                    Economia (R$)
                                  </th>
                                  <th class="text-left">
                                    Crédito do mês (kWh)
                                  </th>
                                  <th class="text-left">
                                    Crédito retido na unidade (kWh)
                                  </th>
                                  <th class="text-left">
                                    Crédito acumulado na unidade (kWh)
                                  </th>
                                  <th class="text-left">
                                    LOG
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item,index) in 10"
                                  :key="index"
                                >
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    {{ index+1 }}
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    {{ index+1 }}
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    0,0100
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    0,0006
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    50
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    1
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    1
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    0,01
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    0,30
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    -0,29
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    49,00
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    49,00
                                  </td>
                                  <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                    49,00
                                  </td>
                                  <td class="text">
                                    (ac)49,00
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </td>
                    </template>
                  </v-data-table> -->
                  <!-- <div class="text mt-2">
                    * Corrigido pela inflação anual: 4,00% <br>
                    ** Corrigido pela inflação anual e pelo percentual definido na Lei 14300. <br>
                    *** Conforme especificação dos fabricantes, os módulos perdem 20% de eficiência em 25 anos. <br>
                    <b>
                      Após 2028, está sendo considerado a continuidade do pagamento de 90% do Fio B.
                    </b>
                  </div> -->
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="propostas-comerciais">
          <v-card class="px-3 py-3">
            <div class="text-center text-h2 my-3">
              Propostas geradas para esta oportunidade
            </div>
            <v-row no-gutters justify="end" align="center" v-if="oportunidade.opu_status === 1">
              <v-btn
                @click="openNovaProposta()"
                color="primary"
                :loading="salvando"
                :disabled="salvando"
              >
                Gerar proposta
              </v-btn>
            </v-row>
            <v-row no-gutters align="center" justify="center" v-if="dadosPropostasComerciais.length === 0">
              <div class="w-100 mt-4" v-if="loadingPropostas">
                <v-card elevation="2" class="px-3 py-16 text-center w-100">
                  <v-progress-circular
                    :size="100"
                    :width="10"
                    indeterminate
                  ></v-progress-circular>
                </v-card>
              </div>
              <div v-else>
                <v-alert
                  class="my-4 text-center fit-content text-white"
                  dense
                  color="blue-grey"
                  :icon="false"
                >
                  Você não gerou propostas para esta oportunidade. <br>
                  Clique no botão para gerar a primeira proposta
                </v-alert>
              </div>
            </v-row>
            <div v-else>
              <v-data-table
                :headers="headersPropostasComerciais"
                :items="dadosPropostasComerciais"
                loading-text="Carregando... Por favor aguarde"
                :loading="loadingPropostas"
                class="elevation-1 base_table mt-4 mb-1"
                :footer-props="{
                  itemsPerPageOptions: [5,10,15,20,25,50,100],
                  showFirstLastPage: true,
                  firstIcon: 'skip_previous',
                  lastIcon: 'skip_next',
                  prevIcon: 'chevron_left',
                  nextIcon: 'chevron_right'
                }"
                :header-props="{
                  sortIcon: 'north',
                }"
                :item-class="item => item.pos_ativo ? '' : 'proposta_inativa'"
              >
                <template v-slot:item.pos_status="{ item }">
                  <v-chip small label :color="statusProposta[item.pos_status - 1].color" class="proposta_chip" text-color="white">
                    {{ statusProposta[item.pos_status - 1].text }}
                  </v-chip>
                </template>
                <template v-slot:item.pos_validade="{ item }">
                  <v-tooltip top v-if="item.pos_status === 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" @click="openDialogAdiarProposta(item)" small label :color="validaValidade(item.pos_validade)" class="proposta_data_validade proposta_chip" text-color="white">
                        {{ $root.Formatter.formatDate(item.pos_validade) }} <v-icon small class="pl-1">edit</v-icon>
                      </v-chip>
                    </template>
                    <span>Alterar data de validade</span>
                  </v-tooltip>
                  <v-chip v-else small label :color="statusProposta[item.pos_status - 1].color" class="proposta_chip">
                    {{ $root.Formatter.formatDate(item.pos_validade) }}
                  </v-chip>
                </template>
                <template v-slot:item.pos_valor_entrada="{ item }">
                  {{ $root.Formatter.floatToMoney(item.pos_valor_entrada) }}
                </template>
                <template v-slot:item.pos_total="{ item }">
                  {{ $root.Formatter.floatToMoney(item.pos_total) }}
                </template>
                <template v-slot:item.acessos="{ item }" class="pt-1 pb-1">
                  <v-chip v-for="acesso in item.acessos" :key="acesso.pra_id" small label color="primary" class="mb-1 mt-1">
                    {{ $root.Formatter.formatDate(acesso.pra_criado_em, 'DD/MM/YYYY HH:mm') }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row no-gutters align="center" justify="center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="openDialogToggleProposta(item)" :color="item.pos_ativo ? 'green' : 'amber darken-4'">
                          {{item.pos_ativo === 1 ? 'toggle_on' : 'toggle_off'}}
                        </v-icon>
                      </template>
                      <span>{{item.pos_ativo === 1 ? 'Desativar' : 'Ativar'}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.pos_ativo && item.pos_status !== 2" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="ml-2" v-bind="attrs" v-on="on" @click="openDialogFecharProposta(item)" :color="retornaCorStatusProposta(item.pos_status)">
                          task
                        </v-icon>
                      </template>
                      <span>{{item.pos_status === 1 ? 'Fechar proposta' : 'Proposta fechada'}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.pos_status !== 2 && item.pos_ativo" top>
                      <template v-slot:activator="{ on, attrs }">
                        <a :href="'/proposta-web/' + item.uuid_pos_id" target="_blank" v-bind="attrs" v-on="on" class="decoration-none">
                          <!-- @click="goToPropostaWeb(item)" -->
                          <v-icon color="primary" class="ml-2">
                            picture_as_pdf
                          </v-icon>
                        </a>
                      </template>
                      <span>Ver proposta web</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="openDialogProposta(item)" color="primary" class="ml-2">
                          edit
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.pos_status !== 3" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteProposta(item)" color="primary" class="ml-2">
                          delete
                        </v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </v-row>
                </template>
              </v-data-table>
            </div>
            <v-dialog v-model="dialogDeleteProposta" max-width="400">
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    Remover Proposta
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogsProposta()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="mb-5">
                  Tem certeza que deseja remover a proposta <b>{{proposta ? proposta.pos_titulo : ''}}</b>?
                </div>
                <v-divider class="mb-3"></v-divider>
                <v-row
                  align="center"
                  justify="space-between"
                  class="px-5 py-5"
                >
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogsProposta()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="removeProposta()"
                  >
                    Remover
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogPropostaInativar" max-width="400">
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    {{inativarProposta.pos_ativo ? 'Desativar' : 'Ativar'}} proposta
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogsPropostaToggle()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="mb-5">
                  Tem certeza que deseja {{inativarProposta.pos_ativo ? 'desativar' : 'ativar'}} a proposta?
                </div>
                <v-divider class="mb-3"></v-divider>
                <v-row
                  align="center"
                  justify="space-between"
                  class="px-5 py-5"
                >
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogsPropostaToggle()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="toggleProposta()"
                  >
                  {{inativarProposta.pos_ativo ? 'Desativar' : 'Ativar'}}
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogPropostaFechar" max-width="500">
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    Fechar proposta
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogsPropostaFechar()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="mb-1">
                  Ao fazer isso o status desta proposta e da oportunidade serão alterados para <b>Fechado</b>.
                </div>
                <div class="mb-5">
                  As demais propostas dessa oportunidade vão ser <b>Desativadas</b>.
                </div>
                <v-divider class="mb-3"></v-divider>
                <v-row
                  align="center"
                  justify="space-between"
                  class="px-5 py-5"
                >
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogsPropostaFechar()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="fecharPropostaOportunidade()"
                  >
                    Fechar proposta
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogProposta"
              persistent
              max-width="400px"
            >
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    {{proposta.uuid_pos_id ? 'Editar' : 'Nova' }} proposta
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogsProposta()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <v-form ref="formPrimeraEtapaProposta">
                  <div class="text">
                    <b>Importante:</b> Confirme as características do sistema que você irá adicionar na proposta comercial.
                  </div>
                  <v-row class="mt-3 mb-2">
                    <v-col cols="12">
                      <v-text-field-percent
                        label="Potência do sistema (kWp)*"
                        outlined
                        v-model="proposta.pos_potencia"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando,
                          rules:[rules.required]
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <v-text-field-percent
                        label="Potência dos módulos (Wp)*"
                        outlined
                        v-model="proposta.pos_potencia_modulo"
                        v-bind:properties="{
                          readonly: false,
                          hideDetails: true,
                          outlined: true,
                          disabled: salvando,
                          loading: salvando,
                          rules:[rules.required]
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '',
                        }"
                      ></v-text-field-percent>
                    </v-col>
                  </v-row>
                </v-form>
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                  <v-btn
                    color="cancel"
                    :disabled="salvando"
                    @click="closeDialogsProposta()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="confirmaDadosProposta()"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    Confirmo os dados
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialogNovaProposta"
              persistent
              max-width="1000px"
            >
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    {{ proposta ? 'Editar' : 'Nova' }} proposta
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogsProposta()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="text-h2 mb-3">
                  Contato
                </div>
                  <v-row>
                    <v-col cols="12" sm="12" md="7" lg="7" xl="7">
                      <v-simple-table class="mb-2" :class="$vuetify.theme.dark ? 'border_table_dark' : 'border_table'">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'" width="30%">
                                <b>
                                  Nome:
                                </b>
                              </td>
                              <td class="text">
                                {{oportunidade.cliente.cli_nome}}
                              </td>
                            </tr>
                            <tr>
                              <td class="text" :class="$vuetify.theme.dark ? 'border_table_dark_right' : 'border_table_right'">
                                <b>
                                  Cidade:
                                </b>
                              </td>
                              <td class="text">
                                {{oportunidade.opu_cidade}}/{{oportunidade.opu_uf}}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="5" xl="5" v-if="loadingSistemaSugeridoProposta">
                      <v-card color="primary" elevation="2" class="px-2 py-2 text-white">
                        <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-1"></v-skeleton-loader>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="5" xl="5" v-if="!loadingSistemaSugeridoProposta && sistemaSugeridoDadosProposta">
                      <v-card color="primary" elevation="2" class="px-2 py-2 text-white">
                        <b>Sistema orçado</b> <br>
                        <div class="text">
                          {{sistemaSugeridoDadosProposta.dim_quantidade_modulos ? sistemaSugeridoDadosProposta.dim_quantidade_modulos : '-'}} módulo{{sistemaSugeridoDadosProposta.dim_quantidade_modulos && sistemaSugeridoDadosProposta.dim_quantidade_modulos.length === 1 ? '' : 's'}} de {{sistemaSugeridoDadosProposta.dim_potencia_modulo ? sistemaSugeridoDadosProposta.dim_potencia_modulo + ' Wp' : '-'}}
                        </div>
                        <div class="text">
                          Potência: {{sistemaSugeridoDadosProposta.dim_potencia ? sistemaSugeridoDadosProposta.dim_potencia + ' kWp' : '-'}}
                        </div>
                        <div class="text" v-if="sistemaSugeridoDadosProposta.dim_tipo_estrutura">
                          Estrutura: {{(tiposEstrutura.filter(item => item.value === sistemaSugeridoDadosProposta.dim_tipo_estrutura))[0].text}}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-2 mb-3"></v-divider>
                  <v-tabs
                    next-icon="chevron_right"
                    centered
                    prev-icon="chevron_left"
                    show-arrows
                    class="ui-tabs"
                    v-model="tabProposta">
                    <v-tab>
                      <v-icon>info</v-icon> Detalhes da proposta
                    </v-tab>
                    <v-tab>
                      <v-icon>shopping_cart</v-icon> Produtos
                    </v-tab>
                    <v-tab>
                      <v-icon>credit_card</v-icon> Pagamento
                    </v-tab>
                    <v-tab>
                      <v-icon>image</v-icon> Imagens
                    </v-tab>
                    <v-tab>
                      <v-icon>format_list_bulleted</v-icon> Termos e condições
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabProposta" class="ui-tabs-inherit">
                    <v-tab-item class="px-1 pb-1">
                      <v-card class="px-3">
                        <v-form ref="formNovaProposta">
                          <v-row class="my-3">
                            <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="pt-0 pb-0">
                              <!-- <v-switch
                                hide-details
                                class="ml-2 mt-0 mb-0"
                                color="success"
                                v-model="proposta.pos_status"
                                :loading="salvando"
                                :disabled="salvando"
                                :label="proposta.pos_status ? 'Ativo': 'Inativo'"
                              ></v-switch> -->
                              <v-autocomplete
                                v-model="proposta.pos_status"
                                autocomplete="off"
                                :items="statusProposta"
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Status*"
                                append-icon="expand_more"
                                outlined
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-0"></v-col>
                            <v-col cols="12" sm="12" md="5" lg="5" xl="5">
                              <v-text-field
                                v-model="proposta.pos_titulo"
                                outlined
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Título da proposta*"
                              ></v-text-field>
                              <!-- <v-text-field
                                v-model="proposta.pos_validade"
                                outlined
                                type="number"
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Validade da proposta (em dias)*"
                              ></v-text-field> -->
                              <v-menu
                                ref="calendarDataValidade"
                                v-model="calendarDataValidade"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    outlined
                                    label="Validade da proposta*"
                                    :rules="[rules.required]"
                                    append-icon="calendar_today"
                                    :loading="salvando"
                                    :disabled="salvando"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-model="dataFormatadaValidade"
                                    v-mask="'##/##/####'"
                                    @input="() => {
                                      calendarDataValidade = false
                                      proposta.pos_validade = $root.Formatter.parseDate(dataFormatadaValidade)
                                      updatePickerModalDataValidade = $root.Formatter.parseDate(dataFormatadaValidade)
                                    }"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  :picker-date.sync="updatePickerModalDataValidade"
                                  year-icon="calendar_today"
                                  prev-icon="chevron_left"
                                  next-icon="chevron_right"
                                  :loading="salvando"
                                  :disabled="salvando"
                                  v-model="dataValidade"
                                ></v-date-picker>
                              </v-menu>
                              <v-text-field
                                v-model="proposta.pos_prazo"
                                outlined
                                hint="Deixe o valor em zero (0) para exibir 'a combinar'"
                                type="number"
                                persistent-hint
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                :min="0"
                                label="Prazo de entrega (em dias)*"
                              ></v-text-field>
                              <v-text-field-percent
                                class="mt-2"
                                label="Distância em km até o local de instalação (Ida e volta)*"
                                outlined
                                v-model="proposta.pos_distancia"
                                v-bind:properties="{
                                  readonly: false,
                                  hideDetails: true,
                                  outlined: true,
                                  disabled: salvando,
                                  loading: salvando,
                                  rules: [rules.required]
                                }"
                                v-bind:options="{
                                  locale: 'pt-BR',
                                  length: 12,
                                  precision: 2,
                                  empty: '',
                                }"
                              ></v-text-field-percent>
                            </v-col>
                            <v-col cols="12" sm="12" md="7" lg="7" xl="7">
                              <v-textarea
                                outlined
                                rows="3"
                                v-model="proposta.pos_detalhes"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Detalhes da proposta"
                              ></v-textarea>
                              <v-textarea
                                outlined
                                rows="3"
                                v-model="proposta.pos_observacao"
                                hide-details
                                :loading="salvando"
                                :disabled="salvando"
                                label="Observação interna (Não será exibida na proposta)"
                              ></v-textarea>
                              <v-switch
                                hide-details
                                class="ml-3 mt-2 mb-2"
                                color="success"
                                v-model="proposta.pos_observacao_admin"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Deixar visível somente para administradores?"
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item class="px-1 pb-1">
                      <v-card class="px-3 pt-2 pb-2 mb-3" style="min-height: 100px">
                        <v-row no-gutters align="center" justify="space-between" class="mt-2">
                          <div class="text-h2">
                            <span v-if="distribuidor.uuid_dis_id && distribuidores.length > 0">
                              <b>
                                {{(distribuidores.filter(item => item.value === distribuidor.uuid_dis_id))[0].text}}
                              </b>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="dialogAlterarDistribuidor = true" color="primary" class="ml-1">
                                    edit
                                  </v-icon>
                                </template>
                                <span>Alterar distribuidor</span>
                              </v-tooltip>
                            </span>
                          </div>
                          <div>
                            <v-btn
                              color="primary"
                              @click="openDialogDistribuidor()"
                              :loading="salvando"
                              :disabled="salvando"
                            >
                              Adicionar produto
                            </v-btn>
                            <v-btn
                              color="primary"
                              @click="openCloseDialog()"
                              class="ml-2"
                              :loading="salvando"
                              :disabled="salvando"
                            >
                              Adicionar produto sem cadastro
                            </v-btn>
                          </div>
                        </v-row>
                        <v-row justify="end" class="w-100 pt-2 pb-1">
                          <v-badge
                            v-for="item in categoriasProdutos"
                            :key="item.value"
                            :content="item.quantidade"
                            :value="item.quantidade"
                            overlap
                            color="orange accent-3"
                          >
                            <v-chip  small label :color="item.color" class="ml-3 mb-2" text-color="white">
                              {{ item.text }}
                            </v-chip>
                          </v-badge>
                        </v-row>
                        <v-data-table
                          :headers="headersProdutos"
                          :items="dadosProdutos"
                          loading-text="Carregando... Por favor aguarde"
                          :loading="carregando"
                          class="elevation-1 base_table mt-4 mb-1"
                          :hide-default-footer="true"
                          :items-per-page="-1"
                          :header-props="{
                            sortIcon: 'north',
                          }"
                        >
                          <template v-slot:item.pro_categoria="{ item }">
                            <v-chip small label :color="retornaCategoria(item).color" class="proposta_chip" text-color="white">
                              {{ retornaCategoria(item).text }}
                            </v-chip>
                          </template>
                          <template v-slot:item.pro_preco_venda="{ item }">
                            {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                          </template>
                          <template v-slot:item.total="{ item }">
                            {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela * item.pro_quantidade) : $root.Formatter.floatToMoney(item.pro_preco_venda  * item.pro_quantidade)}}
                          </template>
                          <template v-slot:item.pro_quantidade="{ item }">
                            <v-row no-gutters align="center" justify="start">
                              <v-icon @click="diminuiQuantidadeProduto(item)">do_not_disturb_on</v-icon>
                              <span class="px-2">{{item.pro_quantidade}}</span>
                              <v-icon @click="aumentaQuantidadeProduto(item)">add_circle</v-icon>
                            </v-row>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-row no-gutters align="center" justify="center">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="confirmaRemoveProduto(item)" color="primary" class="ml-2">
                                    delete
                                  </v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </v-row>
                          </template>
                        </v-data-table>
                        <p class="text-right pt-4 text-h6">
                          Valor total da proposta: <span class="text-h5 font-weight-bold">{{$root.Formatter.floatToMoney(totalProposta)}}</span>
                        </p>
                      </v-card>
                      <v-dialog v-model="dialogRemoveProduto" max-width="400">
                        <v-card class="ui-dialog-top">
                          <v-row align="center" justify="space-between">
                            <v-col cols="10">
                              Remover produto
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <v-icon @click="dialogRemoveProduto = false">close</v-icon>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card class="ui-dialog-content">
                          <div class="mb-5">
                            Tem certeza que deseja remover o produto <b>{{produtoRemover.pro_nome}}</b>?
                          </div>
                          <v-divider class="mb-3"></v-divider>
                          <v-row
                            align="center"
                            justify="space-between"
                            class="px-5 py-5"
                          >
                            <v-btn
                              color="cancel"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="dialogRemoveProduto = false"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="success"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="removeProdutoLista()"
                            >
                              Remover
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-model="dialogDistribuidor"
                        persistent
                        max-width="400px"
                      >
                        <v-card class="ui-dialog-top">
                          <v-row align="center" justify="space-between">
                            <v-col cols="10">
                              Selecione o distribuidor
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <v-icon @click="closeDialogDistribuidor()">close</v-icon>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card class="ui-dialog-content">
                          <v-form ref="formDistribuidor">
                            <v-autocomplete
                              v-model="distribuidor.uuid_dis_id"
                              autocomplete="off"
                              :items="distribuidores"
                              :rules="[rules.required]"
                              :loading="salvando || loadingDistribuidores"
                              :disabled="salvando || loadingDistribuidores"
                              label="Distribuidor*"
                              append-icon="expand_more"
                              outlined
                            ></v-autocomplete>
                          </v-form>
                          <v-divider></v-divider>
                          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                            <v-btn
                              color="cancel"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="closeDialogDistribuidor()"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="primary"
                              @click="selecionaDistribuidor()"
                              :loading="salvando || loadingDistribuidores"
                              :disabled="salvando || loadingDistribuidores"
                            >
                              Selecionar
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-model="dialogProdutoSemCadastro"
                        persistent
                        max-width="1100px"
                      >
                        <v-card class="ui-dialog-top">
                          <v-row align="center" justify="space-between">
                            <v-col cols="10">
                              Selecionar produtos
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <v-icon @click="closeDialogProdutosSemCadastro()">close</v-icon>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card class="ui-dialog-content">
                          <v-form ref="formProdutos" v-if="produtosCategorias && produtosCategorias.length">
                            <!-- centered -->
                            <v-tabs
                              next-icon="chevron_right"
                              prev-icon="chevron_left"
                              show-arrows
                              class="ui-tabs ui-tabs-big"
                              v-model="tabsProdutos">
                              <v-tab v-for="categoria in produtosCategorias" :key="categoria.uuid_cat_id">
                                <v-icon class="mr-1">{{categoria.cat_id > 7 ? `mdi-${categoria.cat_icone}` : categoria.cat_icone}}</v-icon> {{categoria.cat_nome}}
                              </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tabsProdutos" class="ui-tabs-inherit">
                              <!-- KITS -->
                              <v-tab-item class="px-1">
                                <v-card class="px-3 pb-2 mb-3 pt-1">
                                  <v-data-table
                                    multi-sort
                                    class="elevation-1 base_table mt-4"
                                    loading-text="Carregando... Por favor aguarde"
                                    :loading="carregando"
                                    v-model="kitsSelecionados"
                                    :headers="headersKitsSelect"
                                    :search="searchKits"
                                    :items="produtosCategorias[0].produtos"
                                    item-key="kit_id"
                                    show-select
                                    :footer-props="{
                                      itemsPerPageIcon: 'check_box_outline_blank',
                                      itemsPerPageOptions: [5,10,15,20,25,50,100],
                                      firstIcon: 'skip_previous',
                                      lastIcon: 'skip_next',
                                      prevIcon: 'chevron_left',
                                      nextIcon: 'chevron_right'
                                    }"
                                    :header-props="{
                                      sortIcon: 'north',
                                    }"
                                  >
                                    <template v-slot:top>
                                      <div class="py-2 px-2 table_search_area">
                                        <v-text-field
                                          clearable
                                          hide-details=""
                                          clear-icon="close"
                                          v-model="searchKits"
                                          outlined
                                          label="Busca"
                                        ></v-text-field>
                                      </div>
                                    </template>
                                    <template v-slot:header.data-table-select="{ props, on }">
                                      <v-simple-checkbox
                                        color="primary"
                                        v-if="props.indeterminate"
                                        off-icon="check_box_outline_blank"
                                        on-icon="check_box"
                                        indeterminate-icon="indeterminate_check_box"
                                        v-ripple
                                        v-bind="props"
                                        :value="props.indeterminate"
                                        v-on="on"
                                      ></v-simple-checkbox>
                                      <v-simple-checkbox
                                        color="primary"
                                        v-if="!props.indeterminate"
                                        v-ripple
                                        off-icon="check_box_outline_blank"
                                        indeterminate-icon="indeterminate_check_box"
                                        on-icon="check_box"
                                        v-bind="props"
                                        v-on="on"
                                      ></v-simple-checkbox>
                                    </template>
                                    <template v-slot:item.data-table-select="{ isSelected, select, item }">
                                      <v-simple-checkbox
                                        :value="isSelected"
                                        @input="select($event)"
                                        off-icon="check_box_outline_blank"
                                        indeterminate-icon="indeterminate_check_box"
                                        on-icon="check_box"
                                      ></v-simple-checkbox>
                                    </template>
                                    <template v-slot:item.kit_valor="{ item }">
                                      {{ $root.Formatter.floatToMoney(item.kit_valor) }}
                                    </template>
                                  </v-data-table>
                                </v-card>
                              </v-tab-item>
                              <!-- FIM KITS -->
                              <v-tab-item class="px-1" v-if="indexCatProd > 0" v-for="(produtoCategoria, indexCatProd) in produtosCategorias" :key="produtoCategoria.uuid_cat_id + produtoCategoria.cat_id">
                                <v-card class="px-3 pb-2 mb-3 pt-1">
                                  <v-data-table
                                    multi-sort
                                    class="elevation-1 base_table mt-4"
                                    loading-text="Carregando... Por favor aguarde"
                                    :loading="carregando"
                                    v-model="produtosSelecionados"
                                    :headers="headersProdutosSelect"
                                    :search="searchProdutos[indexCatProd]"
                                    :items="produtoCategoria.produtos"
                                    item-key="pro_id"
                                    show-select
                                    :footer-props="{
                                      itemsPerPageIcon: 'check_box_outline_blank',
                                      itemsPerPageOptions: [5,10,15,20,25,50,100],
                                      firstIcon: 'skip_previous',
                                      lastIcon: 'skip_next',
                                      prevIcon: 'chevron_left',
                                      nextIcon: 'chevron_right'
                                    }"
                                    :header-props="{
                                      sortIcon: 'north',
                                    }"
                                  >
                                    <template v-slot:top>
                                      <div class="py-2 px-2 table_search_area">
                                        <v-text-field
                                          clearable
                                          hide-details=""
                                          clear-icon="close"
                                          v-model="searchProdutos[indexCatProd]"
                                          outlined
                                          label="Busca"
                                        ></v-text-field>
                                      </div>
                                    </template>
                                    <template v-slot:header.data-table-select="{ props, on }">
                                      <v-simple-checkbox
                                        color="primary"
                                        v-if="props.indeterminate"
                                        off-icon="check_box_outline_blank"
                                        on-icon="check_box"
                                        indeterminate-icon="indeterminate_check_box"
                                        v-ripple
                                        v-bind="props"
                                        :value="props.indeterminate"
                                        v-on="on"
                                      ></v-simple-checkbox>
                                      <v-simple-checkbox
                                        color="primary"
                                        v-if="!props.indeterminate"
                                        v-ripple
                                        off-icon="check_box_outline_blank"
                                        indeterminate-icon="indeterminate_check_box"
                                        on-icon="check_box"
                                        v-bind="props"
                                        v-on="on"
                                      ></v-simple-checkbox>
                                    </template>
                                    <template v-slot:item.data-table-select="{ isSelected, select, item }">
                                      <v-simple-checkbox
                                        :value="isSelected"
                                        @input="select($event)"
                                        off-icon="check_box_outline_blank"
                                        indeterminate-icon="indeterminate_check_box"
                                        on-icon="check_box"
                                      ></v-simple-checkbox>
                                    </template>
                                    <template v-slot:item.pro_preco_venda="{ item }">
                                      {{item.pro_valor_tabela ? $root.Formatter.floatToMoney(item.pro_valor_tabela) : $root.Formatter.floatToMoney(item.pro_preco_venda)}}
                                    </template>
                                  </v-data-table>
                                </v-card>
                              </v-tab-item>
                            </v-tabs-items>
                          </v-form>
                          <v-divider></v-divider>
                          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                            <v-btn
                              color="cancel"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="closeDialogProdutosSemCadastro()"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="primary"
                              @click="selecionaProdutos()"
                              :loading="salvando"
                              :disabled="salvando"
                            >
                              Selecionar
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogAlterarDistribuidor" max-width="400">
                        <v-card class="ui-dialog-top">
                          <v-row align="center" justify="space-between">
                            <v-col cols="10">
                              Alterar distribuidor
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <v-icon @click="dialogAlterarDistribuidor = false">close</v-icon>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card class="ui-dialog-content">
                          <div class="mb-5">
                            Tem certeza que deseja alterar o distribuidor? <br><br>
                            <b>Esta ação removerá todos os produtos já selecionados</b>
                          </div>
                          <v-divider class="mb-3"></v-divider>
                          <v-row
                            align="center"
                            justify="space-between"
                            class="px-5 py-5"
                          >
                            <v-btn
                              color="cancel"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="dialogAlterarDistribuidor = false"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="success"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="confirmaAlterarDistribuidor()"
                            >
                              Alterar
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-tab-item>
                    <v-tab-item class="px-1 pb-1">
                      <v-card class="px-3 pb-3 mb-3">
                        <v-form ref="formPropostaPagamento">
                          <v-row class="mt-3 mb-0">
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                              <v-autocomplete
                                v-model="proposta.pos_tipo_exibicao"
                                autocomplete="off"
                                :items="modelosProposta"
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Modelo de exibição do valor da proposta*"
                                append-icon="expand_more"
                                outlined
                              ></v-autocomplete>
                              <v-text-field-percent
                                label="Desconto para pagamento à vista*"
                                outlined
                                v-model="proposta.pos_desconto_a_vista"
                                v-bind:properties="{
                                  readonly: false,
                                  hideDetails: true,
                                  outlined: true,
                                  disabled: salvando,
                                  loading: salvando,
                                  rules: [rules.required]
                                }"
                                v-bind:options="{
                                  locale: 'pt-BR',
                                  length: 12,
                                  precision: 2,
                                  empty: '',
                                }"
                              ></v-text-field-percent>
                              <v-autocomplete
                                class="mt-3"
                                v-model="proposta.pos_tipo_calculo"
                                autocomplete="off"
                                :items="valoresCalculosFinanceiro"
                                :rules="[rules.required]"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Qual o valor para o cálculo de financiamento?*"
                                append-icon="expand_more"
                                outlined
                              ></v-autocomplete>
                              <!-- valueWhenIsEmpty="0,00" -->
                              <vuetify-money
                                lazy-validation
                                v-model="proposta.pos_valor_entrada"
                                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                                :disabled="salvando"
                                :loading="salvando"
                                outlined
                                :options="optionsMoney"
                                :rules="[rules.required]"
                                label="Valor de entrada (não será considerado no financiamento)*"
                              ></vuetify-money>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                              <v-textarea
                                outlined
                                v-model="proposta.pos_descricao_pagamento"
                                class="mh_desc"
                                :loading="salvando"
                                :disabled="salvando"
                                label="Descreva o pagamento a prazo"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-form>
                        <v-divider class="mt-0 mb-4"></v-divider>
                        <v-row no-gutters align="center" justify="space-between">
                          <div class="text-h3">
                            Selecione as opções de financiamento que devem ser adicionadas na proposta
                          </div>
                          <v-btn
                            color="primary"
                            @click="dialogFinanciamento = true"

                            :loading="salvando"
                            :disabled="salvando"
                          >
                            Nova opção de financiamento
                          </v-btn>
                        </v-row>
                        <v-dialog
                          v-model="dialogFinanciamento"
                          persistent
                          max-width="500px"
                        >
                          <v-card class="ui-dialog-top">
                            <v-row align="center" justify="space-between">
                              <v-col cols="10">
                                {{financiamento.uuid_bop_id ? 'Editar' : 'Nova'}} opção
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon @click="closeDialogFinanciamento()">close</v-icon>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-card class="ui-dialog-content">
                            <v-form ref="formFinanciamento">
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                                  <v-autocomplete
                                    :menu-props="{ offsetY: true}"
                                    v-model="financiamento.uuid_ban_id"
                                    :items="bancos"
                                    clearable
                                    clear-icon="close"
                                    label="Banco"
                                    append-icon="expand_more"
                                    :loading="salvando"
                                    :disabled="salvando"
                                    outlined
                                    :rules="[rules.required]"
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                                  <v-text-field
                                    v-model="financiamento.bop_nome"
                                    label="Nome* Ex: Financiamento PF ou Financiamento PJ"
                                    :rules="[rules.required]"
                                    autofocus
                                    outlined
                                    :disabled="salvando"
                                    :loading="salvando"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                                  <v-autocomplete
                                    v-model="financiamento.bop_tipo"
                                    autocomplete="on"
                                    :items="calculos"
                                    :rules="[rules.required]"
                                    :loading="salvando"
                                    :disabled="salvando"
                                    label="Tipo de cálculo*"
                                    append-icon="expand_more"
                                    outlined
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                                  <v-text-field
                                    v-model="financiamento.bop_parcelas"
                                    label="Qtde de parcelas em meses* Ex: 24"
                                    :rules="[rules.required]"
                                    outlined
                                    type="number"
                                    :disabled="salvando"
                                    :loading="salvando"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
                                  <v-text-field-percent
                                    label="Percentual de entrada*"
                                    v-model="financiamento.bop_entrada"
                                    v-bind:properties="{
                                      readonly: false,
                                      outlined: true,
                                      suffix: '(%)',
                                      disabled: salvando,
                                      loading: salvando,
                                      rules: [rules.required]
                                    }"
                                    v-bind:options="{
                                      locale: 'pt-BR',
                                      length: 12,
                                      precision: 2,
                                      empty: '',
                                    }"
                                  ></v-text-field-percent>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
                                  <v-text-field-percent
                                    v-model="financiamento.bop_juro_mensal"
                                    label="Taxa de juros mensal*"
                                    v-bind:properties="{
                                      readonly: false,
                                      outlined: true,
                                      suffix: '(%)',
                                      disabled: salvando,
                                      loading: salvando,
                                      rules: [rules.required]
                                    }"
                                    v-bind:options="{
                                      locale: 'pt-BR',
                                      length: 12,
                                      precision: 2,
                                      empty: '',
                                    }"
                                  ></v-text-field-percent>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-divider></v-divider>
                            <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                              <v-btn
                                color="cancel"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="closeDialogFinanciamento()"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="salvarFinanciamento()"
                                :loading="salvando"
                                :disabled="salvando"
                              >
                                Salvar
                              </v-btn>
                            </v-row>
                          </v-card>
                        </v-dialog>
                        <v-data-table
                          :headers="headersFinanciamento"
                          :items="dadosFinanciamento"
                          loading-text="Carregando... Por favor aguarde"
                          :loading="carregando"
                          class="elevation-1 base_table mt-4"
                          :footer-props="{
                            itemsPerPageOptions: [5,10,15,20,25,50,100],
                            showFirstLastPage: true,
                            firstIcon: 'skip_previous',
                            lastIcon: 'skip_next',
                            prevIcon: 'chevron_left',
                            nextIcon: 'chevron_right'
                          }"
                          :header-props="{
                            sortIcon: 'north',
                          }"
                        >
                          <template v-slot:item.bop_tipo="{ item }">
                            {{(calculos.filter(itn => itn.value === item.bop_tipo))[0].text}}
                          </template>
                          <!-- <template v-slot:item.ban_nome="{ item }">
                            <v-row align="center" no-gutters>
                              <img v-if="item.ban_logo" alt="Logotipo" :src="item.ban_logo" class="logotipo"> {{item.ban_nome}}
                            </v-row>
                          </template> -->
                          <template v-slot:item.actions="{ item }">
                            <v-row no-gutters align="center" justify="center">
                              <!-- <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="openDialogFinanciamento(item)" color="primary" class="mr-2">
                                    edit
                                  </v-icon>
                                </template>
                                <span>Editar</span>
                              </v-tooltip> -->
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteFinanciamento(item)" color="primary" class="ml-2">
                                    delete
                                  </v-icon>
                                </template>
                                <span>Excluir</span>
                              </v-tooltip>
                            </v-row>
                          </template>
                        </v-data-table>
                      </v-card>
                      <v-dialog v-model="dialogDeleteFinanciamento" max-width="400">
                        <v-card class="ui-dialog-top">
                          <v-row align="center" justify="space-between">
                            <v-col cols="10">
                              Remover Opção de financiamento
                            </v-col>
                            <v-col cols="2" class="text-right">
                              <v-icon @click="closeDialogFinanciamento()">close</v-icon>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card class="ui-dialog-content">
                          <div class="text-h3 mb-5">
                            Tem certeza que deseja remover esta opção?
                          </div>
                          <v-divider class="mb-3"></v-divider>
                          <v-row
                            align="center"
                            justify="space-between"
                            class="px-5 py-5"
                          >
                            <v-btn
                              color="cancel"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="closeDialogFinanciamento()"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              color="success"
                              :loading="salvando"
                              :disabled="salvando"
                              @click="removeOpcaoFinanciamento()"
                            >
                              Remover
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-tab-item>
                    <v-tab-item class="px-1 pb-1">
                      <v-card class="px-3 pb-3 mb-3">
                        <v-row no-gutters align="center" justify="end" class="mt-1">
                          <v-btn
                            color="primary"
                            @click="dialogImagem = true"
                            :loading="salvando"
                            :disabled="salvando"
                          >
                            Nova imagem
                          </v-btn>
                        </v-row>
                        <v-data-table
                          :headers="headersImagem"
                          :items="dadosImagem"
                          loading-text="Carregando... Por favor aguarde"
                          :loading="carregando"
                          class="elevation-1 base_table mt-4"
                          :footer-props="{
                            itemsPerPageOptions: [5,10,15,20,25,50,100],
                            showFirstLastPage: true,
                            firstIcon: 'skip_previous',
                            lastIcon: 'skip_next',
                            prevIcon: 'chevron_left',
                            nextIcon: 'chevron_right'
                          }"
                          :header-props="{
                            sortIcon: 'north',
                          }"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-row no-gutters align="center" justify="center">
                              <v-tooltip top v-if="!isObject(item.poa_anexo)">
                                <template v-slot:activator="{ on, attrs }">
                                  <a :href="item.poa_anexo" target="_blank" class="decoration-none">
                                    <v-icon v-bind="attrs" v-on="on" color="primary" class="ml-2">
                                      visibility
                                    </v-icon>
                                  </a>
                                </template>
                                <span>Visualizar</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteImagem(item)" color="primary" class="ml-2">
                                    delete
                                  </v-icon>
                                </template>
                                <span>Excluir</span>
                              </v-tooltip>
                            </v-row>
                          </template>
                        </v-data-table>
                        <v-dialog
                          v-model="dialogImagem"
                          persistent
                          max-width="400px"
                        >
                          <v-card class="ui-dialog-top">
                            <v-row align="center" justify="space-between">
                              <v-col cols="10">
                                Nova imagem
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon @click="closeDialogImagem()">close</v-icon>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-card class="ui-dialog-content">
                            <v-form ref="formImagem">
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                                  <v-text-field
                                    v-model="infoImagem.poa_nome"
                                    label="Nome*"
                                    :rules="[rules.required]"
                                    autofocus
                                    outlined
                                    :disabled="salvando"
                                    :loading="salvando"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                                  <v-file-input
                                    show-size
                                    clearable
                                    ref="file"
                                    v-model="infoImagem.poa_anexo"
                                    prepend-icon="image"
                                    label="Adicionar imagem*"
                                    clear-icon="close"
                                    truncate-length="50"
                                    :loading="salvando"
                                    :disabled="salvando"
                                    :rules="[rules.required, rules.size]"
                                    hint="Tamanho máximo permitido: 10MB"
                                    persistent-hint
                                    outlined
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-divider></v-divider>
                            <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                              <v-btn
                                color="cancel"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="closeDialogImagem()"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="salvaImagem()"
                                :loading="salvando"
                                :disabled="salvando"
                              >
                                Salvar
                              </v-btn>
                            </v-row>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDeleteImagem" max-width="400">
                          <v-card class="ui-dialog-top">
                            <v-row align="center" justify="space-between">
                              <v-col cols="10">
                                Remover Imagem
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon @click="dialogDeleteImagem = false">close</v-icon>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-card class="ui-dialog-content">
                            <div class="mb-5">
                              Tem certeza que deseja remover a imagem?
                            </div>
                            <v-divider class="mb-3"></v-divider>
                            <v-row
                              align="center"
                              justify="space-between"
                              class="px-5 py-5"
                            >
                              <v-btn
                                color="cancel"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="closeDialogImagem()"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                color="success"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="removerImagem()"
                              >
                                Remover
                              </v-btn>
                            </v-row>
                          </v-card>
                        </v-dialog>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item class="px-1 pb-1">
                      <v-card class="px-3 pb-3 mb-3">
                        <v-row no-gutters align="center" justify="end" class="mt-1">
                          <v-btn
                            color="primary"
                            @click="dialogTermos = true"
                            :loading="salvando"
                            :disabled="salvando"
                          >
                            Novo termo
                          </v-btn>
                        </v-row>
                        <v-data-table
                          :headers="headersTermos"
                          :items="dadosTermos"
                          loading-text="Carregando... Por favor aguarde"
                          :loading="carregando"
                          class="elevation-1 base_table mt-4"
                          :footer-props="{
                            itemsPerPageOptions: [5,10,15,20,25,50,100],
                            showFirstLastPage: true,
                            firstIcon: 'skip_previous',
                            lastIcon: 'skip_next',
                            prevIcon: 'chevron_left',
                            nextIcon: 'chevron_right'
                          }"
                          :header-props="{
                            sortIcon: 'north',
                          }"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-row no-gutters align="center" justify="center">
                              <!-- <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="openDialogTermos(item)" color="primary" class="mr-2">
                                    edit
                                  </v-icon>
                                </template>
                                <span>Editar</span>
                              </v-tooltip> -->
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteTermos(item)" color="primary" class="ml-2">
                                    delete
                                  </v-icon>
                                </template>
                                <span>Excluir</span>
                              </v-tooltip>
                            </v-row>
                          </template>
                        </v-data-table>
                        <v-dialog
                          v-model="dialogTermos"
                          persistent
                          max-width="400px"
                        >
                          <v-card class="ui-dialog-top">
                            <v-row align="center" justify="space-between">
                              <v-col cols="10">
                                {{infoTermos.id ? 'Editar' : 'Novo'}} termo
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon @click="closeDialogTermos()">close</v-icon>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-card class="ui-dialog-content">
                            <v-form ref="formTermos">
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                                  <v-text-field
                                    v-model="infoTermos.pot_titulo"
                                    label="Título*"
                                    :rules="[rules.required]"
                                    autofocus
                                    outlined
                                    :disabled="salvando"
                                    :loading="salvando"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                                  <v-textarea
                                    outlined
                                    rows="3"
                                    v-model="infoTermos.pot_descricao"
                                    :loading="salvando"
                                    :disabled="salvando"
                                    :rules="[rules.required]"
                                    label="Descrição*"
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-divider></v-divider>
                            <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                              <v-btn
                                color="cancel"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="closeDialogTermos()"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="salvaTermo()"
                                :loading="salvando"
                                :disabled="salvando"
                              >
                                Salvar
                              </v-btn>
                            </v-row>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDeleteTermos" max-width="400">
                          <v-card class="ui-dialog-top">
                            <v-row align="center" justify="space-between">
                              <v-col cols="10">
                                Remover Termo
                              </v-col>
                              <v-col cols="2" class="text-right">
                                <v-icon @click="dialogDeleteTermos = false">close</v-icon>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-card class="ui-dialog-content">
                            <div class="mb-5">
                              Tem certeza que deseja remover o termo {{infoTermos.pot_titulo}}?
                            </div>
                            <v-divider class="mb-3"></v-divider>
                            <v-row
                              align="center"
                              justify="space-between"
                              class="px-5 py-5"
                            >
                              <v-btn
                                color="cancel"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="closeDialogTermos()"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                color="success"
                                :loading="salvando"
                                :disabled="salvando"
                                @click="removerTermo()"
                              >
                                Remover
                              </v-btn>
                            </v-row>
                          </v-card>
                        </v-dialog>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                  <v-btn
                    color="cancel"
                    :disabled="salvando"
                    @click="closeDialogsProposta()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="criarProposta()"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    {{proposta.uuid_pos_id ? 'Editar' : 'Gerar'}} proposta
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog
            v-model="dialogAdiarProposta"
            persistent
            max-width="400px"
          >
            <v-card class="ui-dialog-top">
              <v-row align="center" justify="space-between">
                <v-col cols="10">
                  Alterar data de validade da proposta
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon @click="closeDialogAdiarProposta()">close</v-icon>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="ui-dialog-content">
              <v-form ref="formAdiarProposta">
                <v-menu
                  ref="calendarDataAdiarProposta"
                  v-model="calendarDataAdiarProposta"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      label="Deseja alterar para qual data?*"
                      :rules="[rules.required]"
                      append-icon="calendar_today"
                      :loading="salvando"
                      :disabled="salvando"
                      v-bind="attrs"
                      v-on="on"
                      v-model="dataFormatadaAdiarProposta"
                      v-mask="'##/##/####'"
                      @input="() => {
                        calendarDataAdiarProposta = false
                        adiarProposta.pos_validade = $root.Formatter.parseDate(dataFormatadaAdiarProposta)
                        updatePickerModalDataAdiarProposta = $root.Formatter.parseDate(dataFormatadaAdiarProposta)
                      }"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :picker-date.sync="updatePickerModalDataAdiarProposta"
                    year-icon="calendar_today"
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    :loading="salvando"
                    :disabled="salvando"
                    v-model="dataAdiarProposta"
                  ></v-date-picker>
                </v-menu>
              </v-form>
              <v-divider></v-divider>
              <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="closeDialogAdiarProposta()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="saveAdiarProposta()"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Salvar
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="atividades">
          <v-card class="px-3">
            <v-row class="mt-2">
              <v-col cols="12" sm="6" md="5" lg="5" xl="4">
                <div class="text-h2 mb-3 mt-1">
                  Adicionar nova atividade
                </div>
                <v-form ref="formTarefa">
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                      <v-autocomplete
                        v-model="tarefa.tar_prioridade"
                        autocomplete="off"
                        :items="prioridadesTarefa"
                        :loading="salvando || loadingTarefas"
                        :disabled="salvando || loadingTarefas"
                        :rules="[rules.required]"
                        label="Prioridade*"
                        append-icon="expand_more"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
                      <v-autocomplete
                        :clearable="!tarefa.uuid_tar_id"
                        clear-icon="close"
                        v-model="tarefa.tar_tipo"
                        autocomplete="off"
                        :items="tiposTarefa"
                        :loading="salvando || loadingTarefas"
                        :disabled="salvando || loadingTarefas || !!tarefa.uuid_tar_id"
                        :readonly="!!tarefa.uuid_tar_id"
                        :rules="[rules.required]"
                        label="Tipo*"
                        append-icon="expand_more"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6"  class="pt-0">
                      <v-menu
                        ref="calendarDataTarefa"
                        v-model="calendarDataTarefa"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            label="Data*"
                            :rules="[rules.required]"
                            append-icon="calendar_today"
                            :loading="salvando || loadingTarefas"
                            :disabled="salvando || loadingTarefas || (!!tarefa.uuid_tar_id && tarefa.tar_tipo === 1)"
                            :readonly="!!tarefa.uuid_tar_id && tarefa.tar_tipo === 1"
                            v-bind="attrs"
                            v-on="on"
                            v-model="dataFormatadaTarefa"
                            v-mask="'##/##/####'"
                            @input="() => {
                              calendarDataTarefa = false
                              tarefa.tar_data = $root.Formatter.parseDate(dataFormatadaTarefa)
                              updatePickerModalDataTarefa = $root.Formatter.parseDate(dataFormatadaTarefa)
                            }"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                           v-if="!tarefa.uuid_tar_id || !!tarefa.uuid_tar_id && tarefa.tar_tipo !== 1"
                          :picker-date.sync="updatePickerModalDataTarefa"
                          year-icon="calendar_today"
                          prev-icon="chevron_left"
                          next-icon="chevron_right"
                          :loading="salvando || loadingTarefas"
                          :disabled="salvando || loadingTarefas"
                          v-model="dataTarefa"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6"  class="pt-0">
                      <v-autocomplete
                        v-model="tarefa.tar_status"
                        autocomplete="off"
                        :items="retornaStatusTarefa()"
                        :loading="salvando || loadingTarefas"
                        :disabled="salvando || loadingTarefas"
                        :rules="[rules.required]"
                        label="Status*"
                        append-icon="expand_more"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-textarea
                    outlined
                    no-resize
                    ref="tarefaDesc"
                    rows="3"
                    v-model="tarefa.tar_descricao"
                    :rules="[rules.required]"
                    :loading="salvando || loadingTarefas"
                    :disabled="salvando || loadingTarefas"
                    label="Descrição*"
                  ></v-textarea>
                </v-form>
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                  <div>
                    <v-btn
                      v-if="tarefa.tar_descricao !== ''"
                      @click="closeDialogDeleteTarefa()"
                      :loading="salvando || loadingTarefas"
                      :disabled="salvando || loadingTarefas"
                    >
                      Cancelar
                    </v-btn>
                  </div>
                  <v-btn
                    color="primary"
                    @click="saveEditTarefa()"
                    :loading="salvando || loadingTarefas"
                    :disabled="salvando || loadingTarefas"
                  >
                    Salvar
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="7" lg="7" xl="8" v-if="loadingTarefas">
                <v-card elevation="2" class="px-3 py-16 text-center">
                  <v-progress-circular
                    :size="100"
                    :width="10"
                    indeterminate
                  ></v-progress-circular>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="7" lg="7" xl="8" v-else>
                <v-timeline
                  v-if="tarefasLista.length > 0"
                  align-top
                  dense
                >
                  <v-timeline-item
                    v-for="(item, index) in tarefasLista"
                    :key="index"
                    :color="item.tar_status === 1 ? 'primary' : item.tar_status === 2 ? 'orange' : item.tar_status === 3 ? 'red' : 'success'"
                    large
                  >
                    <template v-slot:icon>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" color="white">
                            {{item.tar_status === 1 ? 'update' : item.tar_status === 2 ? 'today' : item.tar_status === 3 ? 'block' : 'assignment_turned_in'}}
                          </v-icon>
                        </template>
                        <span>{{item.tar_status === 1 ? 'Aberto' : item.tar_status === 2 ? 'Adiado' : item.tar_status === 3 ? 'Cancelado' : 'Concluído'}}</span>
                      </v-tooltip>
                    </template>
                    <v-card max-width="600" :color="item.tar_status === 1 ? 'primary' : item.tar_status === 2 ? 'orange' : item.tar_status === 3 ? 'red' : 'success'">
                      <v-card-title class="text-h6 text-white">
                        <v-row no-gutters justify="space-between" align="center">
                          <div>
                            {{$root.Formatter.formatDate(item.tar_data)}}
                          </div>
                          <div class="text">
                            Prioridade {{(prioridadesTarefa.filter(it => it.value === item.tar_prioridade))[0].text}}
                          </div>
                        </v-row>
                      </v-card-title>
                      <v-card-text class="text--primary pt-2" :class="$vuetify.theme.dark ? 'black' : 'white'" elevation="2">
                        <p>{{item.tar_descricao}}</p>
                        <v-row class="mt-2" no-gutters justify="end">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn fab small color="primary" v-bind="attrs" v-on="on" @click="editarTarefa(item)" class="mr-2 ui-btn-clean ui-btn-rounded btn_personalizado">
                                <v-icon>
                                  edit
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn fab small color="warning" v-bind="attrs" v-on="on" @click="openDialogDeleteTarefa(item)" class="ml-2 ui-btn-clean ui-btn-rounded btn_personalizado">
                                <v-icon>
                                  delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Excluir</span>
                          </v-tooltip>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
                <div v-else>
                  <div class="text-center text-h2 mt-5">
                    Adicione novas atividades <v-icon>mood</v-icon>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-dialog v-model="dialogDeleteTarefa" max-width="400">
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    Remover Atividade
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogDeleteTarefa()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="mb-5">
                  Tem certeza que deseja remover a atividade {{tarefaExcluir.nome}}?
                </div>
                <v-divider class="mb-3"></v-divider>
                <v-row
                  align="center"
                  justify="space-between"
                  class="px-5 py-5"
                >
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogDeleteTarefa()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="removeTarefa()"
                  >
                    Remover
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="anexos">
          <v-card class="px-3">
            <v-row no-gutters align="center" justify="end" class="mt-5">
              <v-btn
                color="primary"
                @click="dialogAnexo = true"
                :loading="salvando"
                :disabled="salvando"
              >
                Novo anexo
              </v-btn>
            </v-row>
            <v-data-table
              :headers="headersAnexo"
              :items="dadosAnexo"
              loading-text="Carregando... Por favor aguarde"
              :loading="loadingAnexos"
              class="elevation-1 base_table mt-4"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:item.opa_arquivo="{ item }">
                <div class="text">
                  <a :href="item.opa_arquivo" target="_blank">
                    {{item.opa_arquivo}}
                  </a>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="center" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteAnexo(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
            <v-dialog
              v-model="dialogAnexo"
              persistent
              max-width="400px"
            >
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    Novo anexo
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="closeDialogAnexo()">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <v-form ref="formAnexo">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                      <v-text-field
                        v-model="infoAnexo.opa_nome"
                        label="Nome*"
                        :rules="[rules.required]"
                        autofocus
                        outlined
                        :disabled="salvando"
                        :loading="salvando"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                      <v-file-input
                        show-size
                        clearable
                        ref="file"
                        v-model="infoAnexo.opa_arquivo"
                        prepend-icon="description"
                        label="Adicionar anexo*"
                        clear-icon="close"
                        truncate-length="50"
                        :rules="[rules.required, rules.size]"
                        hint="Tamanho máximo permitido: 10MB"
                        persistent-hint
                        :loading="salvando"
                        :disabled="salvando"
                        outlined
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-form>
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogAnexo()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="salvaAnexo()"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    Salvar
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDeleteAnexo" max-width="400">
              <v-card class="ui-dialog-top">
                <v-row align="center" justify="space-between">
                  <v-col cols="10">
                    Remover Anexo
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon @click="dialogDeleteAnexo = false">close</v-icon>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="ui-dialog-content">
                <div class="mb-5">
                  Tem certeza que deseja remover o anexo?
                </div>
                <v-divider class="mb-3"></v-divider>
                <v-row
                  align="center"
                  justify="space-between"
                  class="px-5 py-5"
                >
                  <v-btn
                    color="cancel"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="closeDialogAnexo()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="salvando"
                    :disabled="salvando"
                    @click="removeAnexo()"
                  >
                    Remover
                  </v-btn>
                </v-row>
              </v-card>
            </v-dialog>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-dialog
        v-model="dialogEndereco"
        persistent
        max-width="600px"
      >
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Alterar endereço
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="closeDialogEndereco()">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formEndereco">
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-text-field-cep
                  v-model="endereco.opu_cep"
                  label="CEP*"
                  :rules="[rules.required]"
                  @change="searchCep(endereco.opu_cep)"
                  v-bind:properties="{
                    loading: loadingCep || salvando,
                    disabled: loadingCep || salvando,
                    outlined: true,
                    clearable: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '########',
                    empty: null,
                    applyAfter: false,
                  }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="endereco.opu_uf"
                  autocomplete="off"
                  :items="estados"
                  :rules="[rules.required]"
                  :loading="salvando || loadingEstados || loadingCep"
                  :disabled="salvando || loadingEstados || loadingCep"
                  label="Estado*"
                  append-icon="expand_more"
                  outlined
                  @change="filterCidade(endereco.opu_uf)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-autocomplete
                  autocomplete="off"
                  v-model="endereco.opu_cidade"
                  :items="cidadesFiltradas"
                  :loading="salvando || loadingCidades || loadingCep"
                  :disabled="salvando || loadingCidades || loadingCep"
                  label="Cidade*"
                  :rules="[rules.required]"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
                <v-text-field
                  v-model="endereco.opu_bairro"
                  outlined
                  :rules="[rules.required]"
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Bairro*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0 pt-0">
                <v-text-field
                  v-model="endereco.opu_rua"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  :rules="[rules.required]"
                  label="Rua*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="endereco.opu_numero"
                  outlined
                  :loading="salvando || loadingCep"
                  :rules="[rules.required]"
                  :disabled="salvando || loadingCep"
                  label="Número*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0">
                <v-text-field-percent
                  label="Distância ida e volta (km)"
                  outlined
                  v-model="endereco.opu_distancia"
                  v-bind:properties="{
                    readonly: false,
                    hideDetails: true,
                    outlined: true,
                    disabled: salvando,
                    loading: salvando
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 12,
                    precision: 2,
                    empty: '',
                  }"
                ></v-text-field-percent>
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pt-0">
                <v-text-field
                  v-model="endereco.opu_complemento"
                  outlined
                  :loading="salvando || loadingCep"
                  :disabled="salvando || loadingCep"
                  label="Complemento"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :disabled="salvando"
              :loading="salvando"
              @click="closeDialogEndereco()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="editEndereco()"
              :loading="salvando"
              :disabled="salvando"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <produtos-form v-on:cancelar-close="openCloseDialog()" v-on:adiciona-produto="adicionaProdutoLista" :produto_sem_cadastro="true" :abrir_dialog="dialogProduto"></produtos-form>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import Api from '@API'
import moment from 'moment'
import LineChart from '@components/graficos/LineChart.vue'
import BarChart from '@components/graficos/BarChart.vue'
import ProdutosForm from '@pages/produtos/ProdutosForm.vue'
import EtapasOportunidade from './EtapasOportunidade.vue'

export default {
  components: {
    LineChart,
    BarChart,
    ProdutosForm,
    EtapasOportunidade
  },
  data () {
    return {
      loading: true,
      tabs: 0,
      tabsDimensionamento: 0,
      carregando: false,
      salvando: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        max: v => v.length <= 400 || 'Máximo de 400 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      dialogAdiar: false,
      dialogAdiarProposta: false,
      adiar: {
        opu_tipo: 1,
        opu_adiamento_data: '',
        opu_adiamento_descricao: '',
        uuid_opu_id: ''
      },
      adiarProposta: {
        uuid_pos_id: '',
        pos_validade: ''
      },
      dataAdiar: '',
      dataAdiarProposta: '',
      dataFormatadaAdiar: '',
      dataFormatadaAdiarProposta: '',
      updatePickerModalDataAdiar: null,
      updatePickerModalDataAdiarProposta: null,
      calendarDataAdiar: false,
      calendarDataAdiarProposta: false,
      dialogPerda: false,
      motivosPerda: [
        {
          text: 'Contato desistiu da oportunidade',
          value: 1
        },
        {
          text: 'Contato queria saber apenas o preço',
          value: 2
        },
        {
          text: 'Não consegue contato com o cliente',
          value: 3
        },
        {
          text: 'Prazo de entrega',
          value: 4
        },
        {
          text: 'Prazo de instalação',
          value: 5
        },
        {
          text: 'Preço',
          value: 6
        },
        {
          text: 'Problema com financiamento',
          value: 7
        },
        {
          text: 'Outro',
          value: 8
        }
      ],
      perda: {
        opu_status: 2,
        opu_perda_motivo: 1,
        opu_perda_descricao: '',
        uuid_opu_id: ''
      },
      dialogDetalhes: false,
      detalhes: {
        opu_tipo: 1,
        opu_tipo_instalacao: 1,
        opu_probabilidade: 1,
        opu_tipo_estrutura: 1,
        opu_observacao: '',
        uuid_opu_id: ''
      },
      dataDetalhes: '',
      dataFormatadaDetalhes: '',
      updatePickerModalDataDetalhes: null,
      calendarDataDetalhes: false,
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      chances: [
        {
          text: 'Alta',
          value: 1,
          cor: 'success'
        },
        {
          text: 'Média',
          value: 2,
          cor: 'blue'
        },
        {
          text: 'Baixa',
          value: 3,
          cor: 'warning'
        },
        {
          text: 'Não sei',
          value: 4,
          cor: 'gray'
        }
      ],
      modelosPrecificacao: [
        {
          text: 'Faturamento padrão (Minha empresa fatura o kit e o serviço)',
          value: 1
        },
        {
          text: 'Faturamento direto (Distribuidor faz faturamento do kit direto para o cliente)',
          value: 2
        }
      ],
      tiposEstrutura: [],
      usuarios: [],
      loadingUsuarios: false,
      dialogEndereco: false,
      loadingCep: false,
      loadingEstados: false,
      loadingCidades: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      endereco: {
        opu_cep: '',
        opu_uf: '',
        opu_cidade: '',
        opu_bairro: '',
        opu_rua: '',
        opu_numero: '',
        opu_complemento: '',
        opu_distancia: '',
        uuid_opu_id: ''
      },
      headersContasEnergia: [
        {
          text: 'ID',
          align: 'start',
          value: 'opc_id'
        },
        { text: 'Código Unidade consumidora', value: 'opc_unidade_consumidora' },
        { text: 'Modalidade tarifária', value: 'opc_modalidade_tarifaria' },
        { text: 'Padrão de entrada', value: 'opc_entrada_padrao' },
        { text: 'Consumo médio (kWh)', value: 'opc_consumo_mensal' },
        { text: 'Preço do KWh do contato', value: 'opc_valor_kwh' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      dadosContasEnergia: [],
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      dialogContas: false,
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      distribuidoras: [
        {
          text: 'Distribuidora',
          value: 1
        }
      ],
      conta: {
        opc_modalidade_tarifaria: 1,
        opc_entrada_padrao: 1,
        opc_unidade_consumidora: '',
        opc_unidade_consumidora_descricao: 'Padrão',
        opc_consumo_mensal: '',
        opc_consumo_jan: '',
        opc_consumo_fev: '',
        opc_consumo_mar: '',
        opc_consumo_abr: '',
        opc_consumo_mai: '',
        opc_consumo_jun: '',
        opc_consumo_jul: '',
        opc_consumo_ago: '',
        opc_consumo_set: '',
        opc_consumo_out: '',
        opc_consumo_nov: '',
        opc_consumo_dez: '',
        opc_valor_kwh: ''
      },
      dialogDeleteConta: false,
      dialogContaInfo: false,
      entradas: {
        opu_tipo: 1,
        opu_tipo_estrutura: '',
        opu_potencia_modulo: '',
        opu_area_modulo: '',
        opu_percentual_perda: '',
        opu_irradiacao_diaria: '',
        simultaneidade: '60,00%',
        data: '27/01/2023',
        potencia_desejada: 1,
        opu_potencia_desejada: ''
      },
      tiposPotencia: [
        {
          text: 'Dimensionar para uma geração desejada em kWh/mês',
          value: 1
        },
        {
          text: 'Dimensionar para uma área disponível em m²',
          value: 2
        },
        {
          text: 'Dimensionar para uma potência em kWp',
          value: 3
        },
        {
          text: 'Dimensionar pela quantidade de módulos',
          value: 4
        }
      ],
      dialogTipoEstrutura: false,
      tipoEstrutura: '',
      dataEntrada: '',
      dataFormatadaEntrada: '',
      updatePickerModalDataEntrada: null,
      calendarDataEntrada: false,
      dialogGrafico: false,
      optionsChartIrradiacao: {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value
              }
            }
          }]
        },
        plugins: {
          legend: {
            position: 'top'
          }
        }
      },
      chartDataIrradiacao: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        datasets: [
          {
            label: 'Irradiação',
            fill: false,
            backgroundColor: '#004A93',
            borderColor: this.$vuetify.theme.dark ? '#B4B4B4' : '#121212',
            data: [5.399, 5.349, 5.386, 4.86, 4.063, 3.619, 3.934, 4.732, 4.421, 4.931, 5.534, 5.491]
          }
        ]
      },
      barChartOptions: {
        legend: { display: false },
        responsive: true,
        title: {
          display: true,
          position: 'left',
          text: ['Geração prevista (kWh)'],
          fontSize: 14
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'kWh'
              }
            }
          }]
        }
      },
      barChartData: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        datasets: [
          {
            label: 'Irradiação',
            fill: false,
            backgroundColor: '#004A93',
            data: [5.399, 5.349, 5.386, 4.86, 4.063, 3.619, 3.934, 4.732, 4.421, 4.931, 5.534, 5.491]
          }
        ]
      },
      expanded: [],
      // headerUnidadePrincipal: [
      //   {
      //     text: 'ID',
      //     align: 'start',
      //     value: 'id'
      //   },
      //   { text: 'Período', value: 'periodo' },
      //   { text: 'Tarifa (R$)*', value: 'tarifa' },
      //   { text: 'Fio B (R$)**', value: 'fiob' },
      //   { text: 'Simultaneidade', value: 'simultaneidade' },
      //   { text: 'Geração (kWh)***', value: 'geracao' },
      //   { text: 'Consumo total (kWh)', value: 'consumo' },
      //   { text: 'Consumo simultâneo (kWh)', value: 'consumo_simultaneo' },
      //   { text: 'Fatura com solar (R$)', value: 'fatura_com_sistema' },
      //   { text: 'Fatura sem solar (R$)', value: 'fatura_sem_sistema' },
      //   { text: 'Economia', value: 'economia' },
      //   { text: 'Economia acumulada', value: 'economia_acumulada' },
      //   { text: 'Crédito acumulado na unidade (kWh)', value: 'credito_total' },
      //   { text: '', value: 'data-table-expand' }
      // ],
      headerUnidadePrincipal: [
        { text: 'Mês', value: 'periodo', align: 'center' },
        { text: 'Consumo (kWh)', value: 'consumo', align: 'center' },
        { text: 'Geração (kWh)', value: 'geracao', align: 'center' },
        { text: 'Crédito do mês', value: 'credito_mes', align: 'center' },
        { text: 'Crédito acumulado', value: 'credito_total', align: 'center' },
        { text: 'Fatura sem sistema (R$)', value: 'fatura_sem_sistema', align: 'center' },
        { text: 'Fatura com sistema (R$)', value: 'fatura_com_sistema', align: 'center' }
      ],
      dadosUnidadePrincipal: [],
      dialogProposta: false,
      dialogDeleteProposta: false,
      proposta: {
        pos_potencia: '',
        pos_potencia_modulo: '',
        pos_titulo: '',
        pos_validade: '',
        pos_prazo: '',
        pos_distancia: '',
        pos_detalhes: '',
        pos_observacao: '',
        pos_observacao_admin: false,
        pos_tipo_exibicao: 1,
        pos_tipo_calculo: 1,
        pos_desconto_a_vista: '',
        pos_valor_entrada: '',
        pos_descricao_pagamento: '',
        pos_status: true,
        uuid_cli_id: '',
        uuid_opu_id: '',
        uuid_dis_id: '',
        produtos: [],
        bancos: [],
        termos: []
      },
      dialogNovaProposta: false,
      loadingDistribuidores: false,
      dialogDistribuidor: false,
      distribuidores: [],
      distribuidor: {
        uuid_dis_id: ''
      },
      dialogAlterarDistribuidor: false,
      dialogRemoveProduto: false,
      produtoRemover: {},
      tabProposta: 0,
      valoresCalculosFinanceiro: [
        {
          text: 'Valor à vista',
          value: 1
        },
        {
          text: 'Valor a prazo',
          value: 2
        }
      ],
      modelosProposta: [
        {
          text: 'Exibir valor dos produtos e valor total da proposta',
          value: 1
        },
        {
          text: 'Exibir somente valor total da proposta',
          value: 2
        }
      ],
      headersProdutos: [
        { text: 'Categoria', value: 'pro_categoria' },
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' },
        { text: 'Preço Total', value: 'total' },
        { text: 'Quantidade', value: 'pro_quantidade' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosProdutos: [],
      headersFinanciamento: [
        { text: 'Nome', value: 'bop_nome' },
        { text: 'Tipo de cálculo', value: 'bop_tipo' },
        { text: 'Qtde parcelas', value: 'bop_parcelas' },
        { text: 'Percentual de entrada', value: 'bop_entrada' },
        { text: 'Taxa de juros', value: 'bop_juro_mensal' },

        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosFinanciamento: [],
      dialogImagem: false,
      dialogDeleteImagem: false,
      infoImagem: {
        poa_nome: '',
        poa_anexo: []
      },
      headersImagem: [
        { text: 'Nome', value: 'poa_nome' },
        // { text: 'Imagem', value: 'imagem' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosImagem: [],
      dialogTermos: false,
      dialogDeleteTermos: false,
      infoTermos: {
        pot_titulo: '',
        pot_descricao: ''
      },
      headersTermos: [
        { text: 'Título', value: 'pot_titulo' },
        { text: 'Descrição', value: 'pot_descricao' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosTermos: [],
      tarefa: {
        tar_id: '',
        uuid_tar_id: '',
        tar_descricao: '',
        tar_data: new Date(),
        tar_tipo: 2,
        tar_prioridade: 0,
        tar_status: 0,
        uuid_opu_id: this.$route.params.uuid
      },
      tarefaExcluir: {},
      dialogDeleteTarefa: false,
      tiposTarefa: [
        {text: 'Não adiável', color: 'amber darken-4', value: 1},
        {text: 'Adiável', color: 'purple darken-4', value: 2}
      ],
      prioridadesTarefa: [
        {
          text: 'Alta',
          color: 'red darken-4',
          value: 1
        },
        {
          text: 'Média',
          color: 'orange darken-4',
          value: 2
        },
        {
          text: 'Baixa',
          color: 'amber accent-4',
          value: 3
        }
      ],
      tarefaStatus: [
        {
          text: 'Aberto',
          color: 'blue',
          value: 1
        },
        {
          text: 'Adiado',
          color: 'amber accent-4',
          value: 2
        },
        {
          text: 'Cancelado',
          color: 'red',
          value: 3
        },
        {
          text: 'Concluído',
          color: 'green',
          value: 4
        }
      ],
      statusProposta: [
        {
          text: 'Aberto',
          color: 'blue',
          value: 1
        },
        {
          text: 'Cancelado',
          color: 'amber accent-4',
          value: 2
        },
        {
          text: 'Fechado',
          color: 'green',
          value: 3
        }
      ],
      dataTarefa: '',
      dataFormatadaTarefa: '',
      updatePickerModalDataTarefa: null,
      calendarDataTarefa: false,
      loadingTarefas: false,
      tarefasLista: [],
      loadingAnexos: false,
      dialogAnexo: false,
      dialogDeleteAnexo: false,
      dialogProduto: false,
      dialogProdutoSemCadastro: false,
      headersProdutosSelect: [
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Marca', value: 'marca.mar_nome' },
        { text: 'Modelo', value: 'modelo.mod_nome' },
        { text: 'Preço de venda', value: 'pro_preco_venda' }
      ],
      produtosSelecionados: [],
      kitsSelecionados: [],
      headersKitsSelect: [
        { text: 'Nome', value: 'kit_nome' },
        { text: 'Descrição', value: 'kit_descricao' },
        { text: 'Preço de venda', value: 'kit_valor' }
      ],
      searchKits: '',
      tabsProdutos: 0,
      infoAnexo: {
        opa_nome: '',
        opa_arquivo: []
      },
      headersAnexo: [
        { text: 'Nome', value: 'opa_nome' },
        { text: 'Anexo', value: 'opa_arquivo' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      integradores: [],
      calculos: [
        {
          text: 'Tabela Price',
          value: 1
        },
        {
          text: 'Tabela Sac',
          value: 2
        }
      ],
      loadingIntegradores: false,
      dadosAnexo: [],
      dialogFinanciamento: false,
      dialogDeleteFinanciamento: false,
      financiamento: {
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      },
      loadingExatoDimensionamento: false,
      loadingSistemaSugerido: false,
      exatoDimensionamentoDados: [],
      sistemaSugeridoDados: [],
      loadingGraficoGeracao: false,
      dadosGraficoGeracao: [],
      dadosGraficoGeracaoData: [],
      loadingTabelaGeracao: false,
      loadingPropostas: false,
      headersPropostasComerciais: [
        {
          text: 'ID',
          align: 'start',
          value: 'pos_id'
        },
        { text: 'Título', value: 'pos_titulo' },
        { text: 'Status', value: 'pos_status' },
        { text: 'Potência (kWp)', value: 'pos_potencia' },
        { text: 'Potência do módulo (Wp)', value: 'pos_potencia_modulo' },
        { text: 'Validade da proposta', value: 'pos_validade' },
        { text: 'Valor de entrada', value: 'pos_valor_entrada' },
        { text: 'Valor total', value: 'pos_total' },
        { text: 'Últimos acessos', value: 'acessos', width: 120 },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      dadosPropostasComerciais: [],
      dataValidade: '',
      dataFormatadaValidade: '',
      updatePickerModalDataValidade: null,
      calendarDataValidade: false,
      bancos: [],
      dialogPropostaInativar: false,
      inativarProposta: {
        pos_ativo: false
      },
      fecharProposta: {
        pos_status: 3
      },
      dialogPropostaFechar: false,
      loadingSistemaSugeridoProposta: false,
      sistemaSugeridoDadosProposta: null,
      categoriasProdutos: [],
      loadingCategorias: false,
      totalProposta: 0,
      produtosCategorias: [],
      searchProdutos: []
    }
  },
  watch: {
    expanded () {
      if (this.expanded.length > 0) {
        // this.getDadosGrafico(this.expanded[0])
      }
    },
    dataAdiar () {
      this.dataFormatadaAdiar = moment(this.dataAdiar).format('L')
      this.adiar.opu_adiamento_data = this.$root.Formatter.parseDate(this.dataFormatadaAdiar)
      this.calendarDataAdiar = false
    },
    dataAdiarProposta () {
      this.dataFormatadaAdiarProposta = moment(this.dataAdiarProposta).format('L')
      this.adiarProposta.pos_validade = this.$root.Formatter.parseDate(this.dataFormatadaAdiarProposta)
      this.calendarDataAdiarProposta = false
    },
    dataEntrada () {
      this.dataFormatadaEntrada = moment(this.dataEntrada).format('L')
      this.entradas.data = this.$root.Formatter.parseDate(this.dataFormatadaEntrada)
      this.calendarDataEntrada = false
    },
    dataTarefa () {
      this.dataFormatadaTarefa = moment(this.dataTarefa).format('L')
      this.tarefa.tar_data = this.$root.Formatter.parseDate(this.dataFormatadaTarefa)
      this.calendarDataTarefa = false
    },
    dataValidade () {
      this.dataFormatadaValidade = moment(this.dataValidade).format('L')
      this.proposta.pos_validade = this.$root.Formatter.parseDate(this.dataFormatadaValidade)
      this.calendarDataValidade = false
    },
    dadosProdutos () {
      this.totalProposta = 0
      this.dadosProdutos.map(produto => {
        let valor = produto.pro_valor_tabela ? produto.pro_valor_tabela : produto.pro_preco_venda
        this.totalProposta += produto.pro_quantidade * valor
      })
    }
  },
  computed: {
    abrir_dialog () {
      return this.openCloseDialog()
    }
  },
  methods: {
    moment,
    retornaModalidade (item) {
      if (item) {
        let dados = this.modalidades.filter(dad => dad.value === item)
        if (dados[0]) {
          return dados[0].text
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    retornaEntrada (item) {
      if (item) {
        let dados = this.padroes.filter(dad => dad.value === item)
        if (dados[0]) {
          return dados[0].text
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    async getOportunidade () {
      this.loading = true
      await Api.get(`oportunidades/${this.$route.params.uuid}`)
        .then(res => {
          if (res.data) {
            this.oportunidade = res.data
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar a oportunidade!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialogAdiar () {
      this.adiar = {
        opu_tipo: 1,
        opu_adiamento_data: '',
        opu_adiamento_descricao: '',
        uuid_opu_id: this.oportunidade.uuid_opu_id
      }
      this.dialogAdiar = true
    },
    openDialogAdiarProposta (proposta) {
      this.adiarProposta = {
        uuid_pos_id: proposta.uuid_pos_id,
        pos_validade: proposta.pos_validade
      }
      this.dialogAdiarProposta = true
    },
    async saveAdiar () {
      if (!this.$refs.formAdiar.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post('oportunidades/edita', this.adiar)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Adiamento adicionado com sucesso!',
            color: 'success'
          })
          this.closeDialogAdiar()
          this.getOportunidade()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogAdiar () {
      this.adiar = {
        opu_tipo: 1,
        opu_adiamento_data: '',
        opu_adiamento_descricao: '',
        uuid_opu_id: ''
      }
      if (this.$refs.formAdiar) {
        this.$refs.formAdiar.resetValidation()
      }
      this.dataFormatadaAdiar = ''
      this.updatePickerModalDataAdiar = null
      this.dialogAdiar = false
    },
    async saveAdiarProposta () {
      if (!this.$refs.formAdiarProposta.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post(`propostas/${this.adiarProposta.uuid_pos_id}/prorrogar`, this.adiarProposta)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Data de validade alterada com sucesso!',
            color: 'success'
          })
          this.closeDialogAdiarProposta()
          this.getPropostasComerciais()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogAdiarProposta () {
      this.adiarProposta = {
        uuid_pos_id: '',
        pos_validade: ''
      }
      if (this.$refs.formAdiarProposta) {
        this.$refs.formAdiarProposta.resetValidation()
      }
      this.dataFormatadaAdiarProposta = ''
      this.updatePickerModalDataAdiarProposta = null
      this.dialogAdiarProposta = false
    },
    openDialogToggleProposta (item) {
      this.inativarProposta = item
      this.dialogPropostaInativar = true
    },
    openDialogFecharProposta (item) {
      if (item.pos_status === 3) return true
      this.fecharProposta = item
      this.dialogPropostaFechar = true
    },
    closeDialogsPropostaToggle () {
      this.dialogPropostaInativar = false
    },
    closeDialogsPropostaFechar () {
      this.dialogPropostaFechar = false
    },
    async toggleProposta () {
      this.salvando = true
      let data = {
        pos_ativo: !this.inativarProposta.pos_ativo
      }
      await Api.post(`propostas/${this.inativarProposta.uuid_pos_id}/inativar`, data)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Proposta atualizada com sucesso!',
            color: 'success'
          })
          this.closeDialogsPropostaToggle()
          this.getPropostasComerciais()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    async fecharPropostaOportunidade () {
      this.salvando = true
      let data = {
        pos_status: 3
      }
      await Api.post(`propostas/${this.fecharProposta.uuid_pos_id}/fechar`, data)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Proposta atualizada com sucesso!',
            color: 'success'
          })
          this.closeDialogsPropostaFechar()
          location.reload()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialogPerda () {
      this.perda = {
        opu_status: 2,
        opu_perda_motivo: 1,
        opu_perda_descricao: '',
        uuid_opu_id: this.oportunidade.uuid_opu_id
      }
      this.dialogPerda = true
    },
    async savePerda () {
      if (!this.$refs.formPerda.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post('oportunidades/altera/status', this.perda)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Motivo atualizado com sucesso!',
            color: 'success'
          })
          this.closeDialogPerda()
          this.getOportunidade()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogPerda () {
      this.perda = {
        opu_status: 2,
        opu_perda_motivo: 1,
        opu_perda_descricao: '',
        uuid_opu_id: ''
      }
      if (this.$refs.formPerda) {
        this.$refs.formPerda.resetValidation()
      }
      this.dialogPerda = false
    },
    openDialogDetalhes () {
      this.detalhes = {
        opu_tipo: 1,
        opu_tipo_instalacao: this.oportunidade.opu_tipo_instalacao,
        opu_probabilidade: this.oportunidade.opu_probabilidade,
        opu_tipo_estrutura: this.oportunidade.opu_tipo_estrutura,
        opu_observacao: this.oportunidade.opu_observacao,
        uuid_opu_id: this.oportunidade.uuid_opu_id
      }
      this.dialogDetalhes = true
    },
    async saveDetalhes () {
      if (!this.$refs.formDetalhes.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post('oportunidades/edita', this.detalhes)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Detalhes atualizados com sucesso!',
            color: 'success'
          })
          this.closeDialogDetalhes()
          this.getOportunidade()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogDetalhes () {
      this.detalhes = {
        opu_tipo: 1,
        opu_tipo_instalacao: 1,
        opu_probabilidade: 1,
        opu_tipo_estrutura: 1,
        opu_observacao: ''
      }
      if (this.$refs.formDetalhes) {
        this.$refs.formDetalhes.resetValidation()
      }
      this.dataFormatadaDetalhes = ''
      this.updatePickerModalDataDetalhes = null
      this.dialogDetalhes = false
    },
    openDialogEndereco () {
      this.endereco = {
        opu_tipo: 1,
        opu_cep: this.oportunidade.opu_cep,
        opu_uf: this.oportunidade.opu_uf,
        opu_cidade: this.oportunidade.opu_cidade,
        opu_bairro: this.oportunidade.opu_bairro,
        opu_rua: this.oportunidade.opu_rua,
        opu_numero: this.oportunidade.opu_numero,
        opu_complemento: this.oportunidade.opu_complemento,
        opu_distancia: this.oportunidade.opu_distancia,
        uuid_opu_id: this.oportunidade.uuid_opu_id
      }
      if (this.oportunidade.opu_uf) {
        this.filterCidade(this.oportunidade.opu_uf)
      }
      this.dialogEndereco = true
    },
    async editEndereco () {
      if (!this.$refs.formEndereco.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post('oportunidades/edita', this.endereco)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Endereço atualizado com sucesso!',
            color: 'success'
          })
          this.closeDialogEndereco()
          this.getOportunidade()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogEndereco () {
      this.endereco = {
        opu_cep: '',
        opu_uf: '',
        opu_cidade: '',
        opu_bairro: '',
        opu_rua: '',
        opu_numero: '',
        opu_complemento: '',
        opu_distancia: '',
        uuid_opu_id: ''
      }
      if (this.$refs.formEndereco) {
        this.$refs.formEndereco.resetValidation()
      }
      this.dialogEndereco = false
    },
    async getContasEnergia () {
      this.carregando = true
      this.dadosContasEnergia = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/contas`)
        .then(res => {
          if (res.data) {
            this.dadosContasEnergia = res.data
          }
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as contas de energia!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDadosSistema () {
      this.getExatoDimensionamento()
      this.getSistemaSugerido()
    },
    async getExatoDimensionamento () {
      this.loadingExatoDimensionamento = true
      this.exatoDimensionamentoDados = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/dimensionamento/exato`)
        .then(res => {
          if (res.data) {
            this.exatoDimensionamentoDados = res.data
          }
          this.loadingExatoDimensionamento = false
        })
        .catch(err => {
          this.loadingExatoDimensionamento = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do Dimensionamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getSistemaSugerido () {
      this.loadingSistemaSugerido = true
      this.sistemaSugeridoDados = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/dimensionamento/sugerido`)
        .then(res => {
          if (res.data) {
            this.sistemaSugeridoDados = res.data
          }
          this.loadingSistemaSugerido = false
        })
        .catch(err => {
          this.loadingSistemaSugerido = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do Sistema sugerido!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getSistemaSugeridoProposta () {
      this.loadingSistemaSugeridoProposta = true
      this.sistemaSugeridoDadosProposta = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/dimensionamento/sugerido?potencia=${this.proposta.pos_potencia}&potencia_modulo=${this.proposta.pos_potencia_modulo}`)
        .then(res => {
          if (res.data) {
            this.sistemaSugeridoDadosProposta = res.data
          }
          this.loadingSistemaSugeridoProposta = false
        })
        .catch(err => {
          this.loadingSistemaSugeridoProposta = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do Sistema sugerido!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDadosGeracao () {
      this.getDadosGraficoGeracao()
      this.getDadosTabelaGeracao()
    },
    async getDadosGraficoGeracao () {
      this.loadingGraficoGeracao = true
      this.dadosGraficoGeracao = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/dimensionamento/grafico`)
        .then(res => {
          if (res.data) {
            this.dadosGraficoGeracao = res.data
            if (res.data.data) {
              this.dadosGraficoGeracaoData = {
                labels: res.data.labels,
                datasets: [
                  {
                    label: 'Geração do sistema',
                    backgroundColor: '#004A93',
                    data: res.data.data
                  }
                ]
              }
            }
          }
          this.loadingGraficoGeracao = false
        })
        .catch(err => {
          this.loadingGraficoGeracao = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do Gráfico de geração!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDadosTabelaGeracao () {
      this.loadingTabelaGeracao = true
      this.dadosUnidadePrincipal = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/dimensionamento/tabela`)
        .then(res => {
          if (res.data) {
            this.dadosUnidadePrincipal = res.data
          }
          this.loadingTabelaGeracao = false
        })
        .catch(err => {
          this.loadingTabelaGeracao = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados da tabela de geração!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getTarefas () {
      this.loadingTarefas = true
      this.tarefasLista = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/tarefas`)
        .then(res => {
          if (res.data) {
            this.tarefasLista = res.data
          }
          this.loadingTarefas = false
        })
        .catch(err => {
          this.loadingTarefas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as atividades!',
            color: 'error'
          })
          console.log(err)
        })
    },
    editarTarefa (item) {
      this.tarefa = JSON.parse(JSON.stringify(item))
      this.dataFormatadaTarefa = item.tar_data
      this.dataTarefa = item.tar_data
      setTimeout(() => {
        this.$refs.tarefaDesc.focus()
      }, 100)
    },
    retornaStatusTarefa () {
      if (!this.tarefa || this.tarefa.tar_tipo !== 1) return this.tarefaStatus
      return this.tarefaStatus.filter(item => item.value !== 2)
    },
    saveEditTarefa () {
      if (!this.$refs.formTarefa.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'tarefas/novo'
      let editado = false
      if (this.tarefa.uuid_tar_id) {
        endpoint = 'tarefas/edita'
        editado = true
      }
      Api.post(endpoint, this.tarefa)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Tarefa atualizada com sucesso!' : 'Tarefa cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialogDeleteTarefa()
          this.getTarefas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeTarefa () {
      this.salvando = true
      Api.delete(`tarefas/remove/${this.tarefaExcluir.uuid_tar_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogDeleteTarefa = false
          this.salvando = false
          this.closeDialogDeleteTarefa()
          this.getTarefas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover tarefa!',
            color: 'error'
          })
        })
    },
    openDialogContas (item) {
      this.conta = JSON.parse(JSON.stringify(item))
      this.dialogContas = true
    },
    openDialogDeleteConta (item) {
      this.conta = JSON.parse(JSON.stringify(item))
      this.dialogDeleteConta = true
    },
    async saveEditConta (isConsumo = false) {
      if (!isConsumo && !this.$refs.formContas.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = `oportunidades/${this.$route.params.uuid}/contas/novo`
      let editado = false
      if (this.conta.uuid_opc_id) {
        endpoint = `oportunidades/${this.$route.params.uuid}/contas/edita`
        editado = true
      }
      await Api.post(endpoint, this.conta)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Conta atualizada com sucesso!' : 'Conta cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialogContas()
          this.closeDialogConsumo()
          this.getContasEnergia()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogContas () {
      this.conta = {
        opc_modalidade_tarifaria: 1,
        opc_entrada_padrao: 1,
        opc_unidade_consumidora: '',
        opc_unidade_consumidora_descricao: 'Padrão',
        opc_consumo_mensal: '',
        opc_consumo_jan: '',
        opc_consumo_fev: '',
        opc_consumo_mar: '',
        opc_consumo_abr: '',
        opc_consumo_mai: '',
        opc_consumo_jun: '',
        opc_consumo_jul: '',
        opc_consumo_ago: '',
        opc_consumo_set: '',
        opc_consumo_out: '',
        opc_consumo_nov: '',
        opc_consumo_dez: '',
        opc_valor_kwh: ''
      }
      if (this.$refs.formContas) {
        this.$refs.formContas.resetValidation()
      }
      this.dialogContas = false
      this.dialogDeleteConta = false
    },
    async removeConta () {
      this.salvando = true
      await Api.delete(`oportunidades/${this.$route.params.uuid}/contas/remove/${this.conta.uuid_opc_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.closeDialogContas()
          this.getContasEnergia()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover conta!',
            color: 'error'
          })
        })
    },
    openDialogContasInfo (item = false) {
      if (item) {
        this.conta = JSON.parse(JSON.stringify(item))
      }
      this.dialogContaInfo = true
    },
    closeDialogConsumo () {
      if (this.$refs.formConsumo) {
        this.$refs.formConsumo.resetValidation()
      }
      this.dialogContaInfo = false
    },
    closeDialogInfo () {
      this.dialogInfo = false
      if (this.$refs.formConsumo) {
        this.$refs.formConsumo.resetValidation()
      }
    },
    atualizaCamposConsumo (valor) {
      if (this.conta.opc_consumo_jan === '' || this.conta.opc_consumo_jan === null) {
        this.conta.opc_consumo_jan = valor
      }
      if (this.conta.opc_consumo_fev === '' || this.conta.opc_consumo_fev === null) {
        this.conta.opc_consumo_fev = valor
      }
      if (this.conta.opc_consumo_mar === '' || this.conta.opc_consumo_mar === null) {
        this.conta.opc_consumo_mar = valor
      }
      if (this.conta.opc_consumo_abr === '' || this.conta.opc_consumo_abr === null) {
        this.conta.opc_consumo_abr = valor
      }
      if (this.conta.opc_consumo_mai === '' || this.conta.opc_consumo_mai === null) {
        this.conta.opc_consumo_mai = valor
      }
      if (this.conta.opc_consumo_jun === '' || this.conta.opc_consumo_jun === null) {
        this.conta.opc_consumo_jun = valor
      }
      if (this.conta.opc_consumo_jul === '' || this.conta.opc_consumo_jul === null) {
        this.conta.opc_consumo_jul = valor
      }
      if (this.conta.opc_consumo_ago === '' || this.conta.opc_consumo_ago === null) {
        this.conta.opc_consumo_ago = valor
      }
      if (this.conta.opc_consumo_set === '' || this.conta.opc_consumo_set === null) {
        this.conta.opc_consumo_set = valor
      }
      if (this.conta.opc_consumo_out === '' || this.conta.opc_consumo_out === null) {
        this.conta.opc_consumo_out = valor
      }
      if (this.conta.opc_consumo_nov === '' || this.conta.opc_consumo_nov === null) {
        this.conta.opc_consumo_nov = valor
      }
      if (this.conta.opc_consumo_dez === '' || this.conta.opc_consumo_dez === null) {
        this.conta.opc_consumo_dez = valor
      }
      this.calculaMediaConta()
    },
    calculaMediaConta () {
      let valor = 0
      valor = (Number(this.conta.opc_consumo_jan) + Number(this.conta.opc_consumo_fev) + Number(this.conta.opc_consumo_mar) + Number(this.conta.opc_consumo_abr) + Number(this.conta.opc_consumo_mai) + Number(this.conta.opc_consumo_jun) + Number(this.conta.opc_consumo_jul) + Number(this.conta.opc_consumo_ago) + Number(this.conta.opc_consumo_set) + Number(this.conta.opc_consumo_out) + Number(this.conta.opc_consumo_nov) + Number(this.conta.opc_consumo_dez)) / 12
      this.conta.opc_consumo_mensal = valor
    },
    openDialogTipoEstrutura (item) {
      this.tipoEstrutura = item
      this.entradas = {
        opu_tipo: 1,
        opu_tipo_estrutura: this.oportunidade.opu_tipo_estrutura,
        opu_potencia_modulo: this.oportunidade.opu_potencia_modulo,
        opu_area_modulo: this.oportunidade.opu_area_modulo,
        opu_irradiacao_diaria: this.oportunidade.opu_irradiacao_diaria,
        opu_percentual_perda: this.oportunidade.opu_percentual_perda,
        simultaneidade: '60,00%',
        data: '27/01/2023',
        potencia_desejada: 1,
        opu_potencia_desejada: this.oportunidade.opu_potencia_desejada,
        uuid_opu_id: this.oportunidade.uuid_opu_id
      }
      this.dialogTipoEstrutura = true
    },
    async editTipoEstrutura () {
      if (!this.$refs.formTipoEstrutura.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      await Api.post('oportunidades/edita', this.entradas)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Dados atualizados com sucesso!',
            color: 'success'
          })
          this.closeDialogTipoEstrutura()
          this.getOportunidade()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogTipoEstrutura () {
      this.tipoEstrutura = ''
      this.dataFormatadaEntrada = ''
      this.updatePickerModalDataEntrada = null
      this.dialogEntrada = false
      this.dialogTipoEstrutura = false
      this.entradas = {
        opu_tipo: 1,
        opu_tipo_estrutura: '',
        opu_potencia_modulo: '',
        opu_area_modulo: '',
        opu_percentual_perda: '',
        opu_irradiacao_diaria: '',
        simultaneidade: '60,00%',
        data: '27/01/2023',
        potencia_desejada: 1,
        opu_potencia_desejada: ''
      }
    },
    openNovaProposta () {
      this.proposta.pos_potencia = this.sistemaSugeridoDados.dim_potencia
      this.proposta.pos_potencia_modulo = this.sistemaSugeridoDados.dim_potencia_modulo
      this.dialogProposta = true
    },
    openDialogProposta (item) {
      this.proposta = JSON.parse(JSON.stringify(item))
      this.dataFormatadaValidade = moment(item.pos_validade).format('L')
      this.dataValidade = item.pos_validade
      this.distribuidor.uuid_dis_id = item.distribuidor ? item.distribuidor.uuid_dis_id : 'sem-distribuidor'
      this.dadosProdutos = this.proposta.produtos
      this.dadosFinanciamento = this.proposta.bancos
      this.dadosTermos = this.proposta.termos
      this.dadosImagem = this.proposta.anexos
      this.quantidadePorCategoria()
      this.dialogProposta = true
    },
    openDialogDeleteProposta (item) {
      this.proposta = JSON.parse(JSON.stringify(item))
      this.dialogDeleteProposta = true
    },
    removeProposta () {
      this.salvando = true
      Api.delete(`propostas/remove/${this.proposta.uuid_pos_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.closeDialogsProposta()
          this.getPropostasComerciais()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover proposta!',
            color: 'error'
          })
        })
    },
    confirmaDadosProposta () {
      if (!this.$refs.formPrimeraEtapaProposta.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.getDistributors()
      if (!this.proposta.uuid_pos_id) {
        this.getOpcoesFinanciamentoPadrao()
      }
      this.getSistemaSugeridoProposta()
      this.dialogProposta = false
      this.tabProposta = 2
      setTimeout(() => {
        this.tabProposta = 0
      })
      this.dialogNovaProposta = true
    },
    closeDialogsProposta () {
      this.proposta = {
        pos_potencia: '',
        pos_potencia_modulo: '',
        pos_titulo: '',
        pos_validade: '',
        pos_prazo: '',
        pos_distancia: '',
        pos_detalhes: '',
        pos_observacao: '',
        pos_observacao_admin: false,
        pos_tipo_exibicao: 1,
        pos_tipo_calculo: 1,
        pos_desconto_a_vista: '',
        pos_valor_entrada: '',
        pos_descricao_pagamento: '',
        pos_status: true,
        uuid_cli_id: '',
        uuid_opu_id: '',
        uuid_dis_id: '',
        produtos: [],
        bancos: [],
        termos: []
      }
      if (this.$refs.formNovaProposta) {
        this.$refs.formNovaProposta.resetValidation()
      }
      if (this.$refs.formPrimeraEtapaProposta) {
        this.$refs.formPrimeraEtapaProposta.resetValidation()
      }
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.dialogDeleteProposta = false
      this.dialogProposta = false
      this.dialogNovaProposta = false
      this.dataFormatadaValidade = ''
      this.dadosProdutos = []
      this.dadosFinanciamento = []
      this.dadosTermos = []
      this.dadosImagem = []
      this.resetQuantidadeCategoria()
    },
    resetQuantidadeCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })
    },
    openDialogDistribuidor () {
      if (this.distribuidor.uuid_dis_id === '') {
        this.getDistributors()
        this.dialogDistribuidor = true
      } else {
        this.selecionaDistribuidor()
      }
    },
    confirmaAlterarDistribuidor () {
      this.distribuidor = {
        uuid_dis_id: ''
      }
      this.dadosProdutos = []
      this.dialogAlterarDistribuidor = false
      this.quantidadePorCategoria()
      this.openDialogDistribuidor()
    },
    validaValidade (dataValidade) {
      let validade = moment(dataValidade).format('YYYY-MM-DD')
      let hoje = moment().format('YYYY-MM-DD')
      if (hoje > validade) return 'red'
      if (hoje === validade) return 'amber darken-4'
      if (hoje < validade) return 'green'
    },
    retornaCorStatusProposta (status) {
      if (status === 1) return 'primary'
      if (status === 2) return 'red'
      return 'green'
    },
    async getDistributors () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores/distribuidores-vinculados')
        .then(res => {
          let info = []
          info.push({
            value: 'sem-distribuidor',
            text: 'Sem distribuidor'
          })
          res.data.map(item => {
            info.push({
              value: item.uuid_dis_id,
              text: item.dis_nome_fantasia ? item.dis_nome_fantasia : item.dis_nome
            })
          })
          this.distribuidores = info
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    closeDialogDistribuidor () {
      // this.distribuidor = {
      //   uuid_dis_id: ''
      // }
      this.dialogDistribuidor = false
    },
    async selecionaDistribuidor () {
      if (this.$refs.formDistribuidor) {
        if (!this.$refs.formDistribuidor.validate()) {
          this.$root.SnackControl.open(this, {
            text: 'Por favor, preencha os campos corretamente.',
            color: 'warning'
          })
          return
        }
      }
      this.salvando = true
      let endpoint = `produtos/distribuidor/${this.distribuidor.uuid_dis_id}?show_kits=true`

      if (this.$root.Permissions.admin() && !!this.oportunidade.integrador) {
        endpoint = endpoint + '&integrador=' + this.oportunidade.integrador.uuid_int_id
      }
      await Api.get(endpoint)
        .then(res => {
          this.dialogDistribuidor = false
          this.dialogProdutoSemCadastro = true
          this.salvando = false
          this.produtosCategorias = res.data
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    quantidadePorCategoria () {
      this.categoriasProdutos.map(categoria => {
        categoria.quantidade = 0
      })

      this.dadosProdutos.map(produto => {
        console.log(produto, 'produto')
        let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
        if (!categoria && produto.fk_kit_id_kit) {
          categoria = this.categoriasProdutos[0]
        }
        categoria.quantidade += produto.pro_quantidade
      })
    },
    selecionaProdutos () {
      let produtosTodos = this.produtosSelecionados
      produtosTodos.map((pro) => {
        if (pro.pro_quantidade === 0) {
          pro.pro_quantidade = 1
        }
      })
      let kitsTodos = this.kitsSelecionados
      kitsTodos.map((kit) => {
        if (kit.pro_quantidade === 0) {
          kit.pro_quantidade = 1
        }
      })
      let novosProdutos = this.dadosProdutos.concat(this.produtosSelecionados)
      novosProdutos = novosProdutos.concat(this.kitsSelecionados)
      this.dadosProdutos = novosProdutos
      this.quantidadePorCategoria()
      this.closeDialogProdutosSemCadastro()
    },
    aumentaQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade = pro.pro_quantidade + 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    diminuiQuantidadeProduto (item) {
      let produtosTodos = []
      produtosTodos = this.dadosProdutos
      produtosTodos.filter((pro) => {
        if (pro === item) {
          pro.pro_quantidade > 1 ? (pro.pro_quantidade = pro.pro_quantidade - 1) : pro.pro_quantidade = 1
        }
      })
      this.dadosProdutos = JSON.parse(JSON.stringify(produtosTodos))
      this.quantidadePorCategoria()
    },
    confirmaRemoveProduto (item) {
      this.produtoRemover = item
      this.dialogRemoveProduto = true
    },
    removeProdutoLista () {
      let produtosAutalizados = this.dadosProdutos.filter((pro) => pro.pro_nome !== this.produtoRemover.pro_nome)
      this.produtoRemover = {}
      this.dialogRemoveProduto = false
      this.dadosProdutos = produtosAutalizados
    },
    adicionaProdutoLista (item) {
      item.pro_quantidade = 1
      item.pro_id = null
      this.dadosProdutos.push(item)
      this.quantidadePorCategoria()
    },
    async getOpcoesFinanciamentoPadrao () {
      this.salvando = true
      this.carregando = true
      await Api.get(`bancos/padroes`)
        .then(res => {
          let opcoes = []
          if (res.data.length > 0) {
            res.data.map(ban => {
              if (ban.opcoes.length > 0) {
                ban.opcoes.map(fin => {
                  opcoes.push(fin)
                })
              }
            })
            this.dadosFinanciamento = opcoes
          }
          this.salvando = false
          this.carregando = false
        })
        .catch(err => {
          this.salvando = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as opções de financiamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async criarProposta () {
      if (!this.$refs.formNovaProposta.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        this.tabProposta = 0
        return
      }
      if (this.dadosProdutos.length === 0) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, adicione pelo menos um produto na proposta.',
          color: 'warning'
        })
        this.tabProposta = 1
        return
      }
      if (!this.$refs.formPropostaPagamento.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        this.tabProposta = 2
        return
      }
      if (this.dadosFinanciamento.length === 0) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, adicione pelo menos um opção de financiamento.',
          color: 'warning'
        })
        this.tabProposta = 2
        return
      }
      this.proposta.uuid_cli_id = this.oportunidade.cliente.uuid_cli_id
      this.proposta.uuid_opu_id = this.oportunidade.uuid_opu_id
      this.proposta.uuid_dis_id = this.distribuidor.uuid_dis_id
      this.proposta.produtos = this.dadosProdutos
      this.proposta.bancos = this.dadosFinanciamento
      this.proposta.termos = this.dadosTermos
      this.salvando = true
      let endpoint = 'propostas/novo'
      let editado = false
      if (this.proposta.uuid_pos_id) {
        endpoint = 'propostas/edita'
        editado = true
      }
      console.log(this.proposta, 'this.proposta')
      await Api.post(endpoint, this.proposta)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (this.dadosImagem.length > 0) {
            this.enviaAnexosProposta(response.data.uuid_pos_id, this.dadosImagem, editado)
          } else {
            this.closeDialogsProposta()
            this.getPropostasComerciais()
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Proposta atualizada com sucesso!' : 'Proposta cadastrada com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return false
      }
    },
    enviaAnexosProposta (uuid, itens, editar) {
      let anexos = itens
      let statusEdicao = editar ? 'edita' : 'novo'
      anexos.map(item => {
        if (this.isObject(item.poa_anexo)) {
          const formData = new FormData()
          formData.append('poa_nome', item.poa_nome)
          formData.append('poa_anexo', item.poa_anexo)
          Api.post(`propostas/${uuid}/anexos/${statusEdicao}`, formData)
            .then((response) => {
              console.log(response)
            })
            .catch((error) => {
              this.salvando = false
              console.log(error.response)
              this.$root.SnackControl.open(this, {
                text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
                color: 'error'
              })
            })
        }
        // else {
        //   Api.post(`propostas/${uuid}/anexos/${statusEdicao}`, item)
        //     .then((response) => {
        //       console.log('response anexo')
        //       console.log(response)
        //     })
        //     .catch((error) => {
        //       this.salvando = false
        //       console.log(error.response)
        //       this.$root.SnackControl.open(this, {
        //         text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
        //         color: 'error'
        //       })
        //     })
        // }
      })
      this.closeDialogsProposta()
      this.getPropostasComerciais()
    },
    formatDate (date) {
      return moment(date).format('L')
    },
    goToContato (item) {
      this.$router.push({ name: 'Contato', params: { uuid: item } }).catch(() => {})
    },
    async getAnexos () {
      this.loadingAnexos = true
      this.dadosAnexo = []
      await Api.get(`oportunidades/${this.$route.params.uuid}/anexos`)
        .then(res => {
          if (res.data) {
            this.dadosAnexo = res.data
          }
          this.loadingAnexos = false
        })
        .catch(err => {
          this.loadingAnexos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os anexos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    salvaAnexo () {
      if (!this.$refs.formAnexo.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = `oportunidades/${this.$route.params.uuid}/anexos/novo`
      let editado = false
      if (this.infoAnexo.uuid_opa_id) {
        endpoint = `oportunidades/${this.$route.params.uuid}/anexos/edita`
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.infoAnexo).map((key) => {
        if (key === 'opa_arquivo') {
          if (this.$refs.file) {
            formData.append(`opa_arquivo`, this.infoAnexo.opa_arquivo)
          }
        } else {
          if (this.infoAnexo[key] != null) {
            formData.append(key, this.infoAnexo[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Anexo atualizado com sucesso!' : 'Anexo cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialogAnexo()
          this.getAnexos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialogDeleteAnexo (item) {
      this.infoAnexo = JSON.parse(JSON.stringify(item))
      this.dialogDeleteAnexo = true
    },
    removeAnexo () {
      this.salvando = true
      Api.delete(`oportunidades/${this.oportunidade.uuid_opu_id}/anexos/remove/${this.infoAnexo.uuid_opa_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.closeDialogAnexo()
          this.getAnexos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover anexo!',
            color: 'error'
          })
        })
    },
    closeDialogAnexo () {
      this.infoAnexo = {
        opa_nome: '',
        opa_arquivo: []
      }
      if (this.$refs.formAnexo) {
        this.$refs.formAnexo.resetValidation()
      }
      this.dialogDeleteAnexo = false
      this.dialogAnexo = false
    },
    async getPropostasComerciais () {
      this.loadingPropostas = true
      this.dadosPropostasComerciais = []
      await Api.get(`propostas?oportunidade=${this.$route.params.uuid}`)
        .then(res => {
          if (res.data) {
            this.dadosPropostasComerciais = res.data
          }
          this.loadingPropostas = false
        })
        .catch(err => {
          this.loadingPropostas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as propostas comerciais!',
            color: 'error'
          })
          console.log(err)
        })
    },
    goToPropostaWeb (item) {
      this.$router.push({ name: 'PropostaWeb', params: { uuid: item.uuid_pos_id } }).catch(() => {})
    },
    closeDialogImagem () {
      this.infoImagem = {
        poa_nome: '',
        poa_anexo: []
      }
      if (this.$refs.formImagem) {
        this.$refs.formImagem.resetValidation()
      }
      this.dialogDeleteImagem = false
      this.dialogImagem = false
    },
    openDialogDeleteImagem (item) {
      this.infoImagem = JSON.parse(JSON.stringify(item))
      this.dialogDeleteImagem = true
    },
    salvaImagem () {
      if (!this.$refs.formImagem.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.dadosImagem.push(this.infoImagem)
      this.closeDialogImagem()
    },
    removerImagem () {
      let imagensAtualizadas = this.dadosImagem.filter((ima) => ima.poa_nome !== this.infoImagem.poa_nome)
      this.dadosImagem = imagensAtualizadas
      if (this.infoImagem.uuid_poa_id) {
        this.salvando = true
        Api.delete(`propostas/${this.proposta.uuid_pos_id}/anexos/remove/${this.infoImagem.uuid_poa_id}`)
          .then(res => {
            this.$root.SnackControl.open(this, {
              text: res.data.msg
            })
            this.salvando = false
            this.closeDialogImagem()
          })
          .catch(err => {
            console.log(err)
            this.salvando = false
            this.$root.SnackControl.open(this, {
              text: err.response ? err.response.data.message : 'Erro ao remover imagem!',
              color: 'error'
            })
          })
      } else {
        this.closeDialogImagem()
      }
    },
    salvaTermo () {
      if (!this.$refs.formTermos.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.dadosTermos.push(this.infoTermos)
      this.closeDialogTermos()
    },
    removerTermo () {
      let termosAtualizados = this.dadosTermos.filter((ter) => ter.pot_titulo !== this.infoTermos.pot_titulo)
      this.dadosTermos = termosAtualizados
      this.closeDialogTermos()
    },
    closeDialogTermos () {
      this.infoTermos = {
        pot_titulo: '',
        pot_descricao: ''
      }
      if (this.$refs.formTermos) {
        this.$refs.formTermos.resetValidation()
      }
      this.dialogDeleteTermos = false
      this.dialogTermos = false
    },
    openDialogDeleteTermos (item) {
      this.infoTermos = JSON.parse(JSON.stringify(item))
      this.dialogDeleteTermos = true
    },
    openDialogTermos (item) {
      this.infoTermos = JSON.parse(JSON.stringify(item))
      this.dialogTermos = true
    },
    openDialogDeleteTarefa (item) {
      this.tarefaExcluir = JSON.parse(JSON.stringify(item))
      this.dialogDeleteTarefa = true
    },
    closeDialogDeleteTarefa () {
      this.tarefaExcluir = {}
      this.tarefa = {
        tar_id: '',
        uuid_tar_id: '',
        tar_descricao: '',
        tar_data: new Date(),
        tar_tipo: 2,
        tar_prioridade: 0,
        tar_status: 0,
        uuid_opu_id: this.$route.params.uuid
      }
      this.dataFormatadaTarefa = ''
      this.updatePickerModalDataTarefa = null
      if (this.$refs.formTarefa) {
        this.$refs.formTarefa.resetValidation()
      }
      this.dialogDeleteTarefa = false
    },
    abrirNovaProposta () {
      this.$router.push(
        {
          name: 'OportunidadeInterna',
          params: { uuid: this.$route.params.uuid },
          hash: '#propostas-comerciais'
        }
      ).catch(() => {})
      this.tabs = 'propostas-comerciais'
      this.dialogProposta = true
    },
    openCloseDialog () {
      this.dialogProduto = !this.dialogProduto
      return this.dialogProduto
    },
    closeDialogProdutosSemCadastro () {
      this.produtosSelecionados = []
      this.kitsSelecionados = []
      this.dialogProdutoSemCadastro = false
      this.tabsProdutos = 0
    },
    openDialogFinanciamento (item) {
      this.financiamento = JSON.parse(JSON.stringify(item))
      this.dialogFinanciamento = true
    },
    openDialogDeleteFinanciamento (item) {
      this.financiamento = JSON.parse(JSON.stringify(item))
      this.dialogDeleteFinanciamento = true
    },
    closeDialogFinanciamento () {
      this.financiamento = {
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      }
      if (this.$refs.formFinanciamento) {
        this.$refs.formFinanciamento.resetValidation()
      }
      this.dialogDeleteFinanciamento = false
      this.dialogFinanciamento = false
    },
    removeOpcaoFinanciamento () {
      let financiamentosAtualizados = this.dadosFinanciamento.filter((fin) => fin.bop_nome !== this.financiamento.bop_nome)
      this.closeDialogFinanciamento()
      this.dadosFinanciamento = financiamentosAtualizados
    },
    salvarFinanciamento () {
      if (!this.$refs.formFinanciamento.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.dadosFinanciamento.push(this.financiamento)
      this.closeDialogFinanciamento()
    },
    alteraStatusEtapa (posicao) {
      this.itens_funil.map((item, index) => {
        item.concluido = !item.concluido
        if (posicao > index) {
          item.concluido = true
        }
        if (posicao < index) {
          item.concluido = false
        }
      })
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    async getUsuarios () {
      this.loadingUsuarios = true
      await Api.get(`usuarios`)
        .then(res => {
          if (res.data) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.usu_nome,
                value: item.uuid_usu_id
              })
            })
            this.usuarios = info
          }
          this.loadingUsuarios = false
        })
        .catch(err => {
          this.loadingUsuarios = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
          console.log(err)
        })
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.endereco.opu_rua = response.data.logradouro
              this.endereco.opu_bairro = response.data.bairro
              this.endereco.opu_complemento = response.data.complemento
              if (response.data.uf) {
                this.endereco.opu_uf = response.data.uf
                this.endereco.opu_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    async getBancos () {
      await Api.get('bancos')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_ban_id,
                text: item.ban_nome
              })
            })
            this.bancos = info
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os bancos!',
            color: 'error'
          })
        })
    },
    async getIntegrators () {
      this.loadingIntegradores = true
      await Api.get('integradores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_int_id,
                text: item.int_nome
              })
            })
            this.integradores = info
            this.loadingIntegradores = false
          }
        })
        .catch(err => {
          console.log(err)
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os integradores!',
            color: 'error'
          })
        })
    },
    async getCategorias () {
      this.loadingCategorias = true
      await Api.get('produtos/categorias')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            info.push({
              cat_id: 0,
              text: 'Kits',
              value: 'kits',
              color: 'blue darken-4',
              quantidade: 0
            })
            res.data.map(item => {
              info.push({
                cat_id: item.cat_id,
                text: item.cat_nome,
                value: item.uuid_cat_id,
                color: item.cat_cor,
                quantidade: 0
              })
            })
          }
          this.categoriasProdutos = info
          this.loadingCategorias = false
        })
        .catch(err => {
          this.loadingCategorias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaCategoria (produto) {
      let categoria = this.categoriasProdutos.find(cat => cat.cat_id === produto.pro_categoria)
      if (!categoria && produto.fk_kit_id_kit) {
        categoria = this.categoriasProdutos[0]
      }
      if (!categoria) {
        categoria = {
          cat_id: 1000,
          text: 'Categoria removida',
          value: null,
          color: 'red accent-4'
        }
      }

      return categoria
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.tie_nome,
                value: item.tie_id
              })
            })
            this.tiposEstrutura = info
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    loadFunctions () {
      this.getCategorias()
      this.getEstados()
      this.getCidade()
      this.getIntegrators()
      this.getOportunidade()
      this.getTiposEstrutura()
      this.getBancos()
      this.getDadosSistema()
      // this.getUsuarios()
      if (this.$route.hash === '#contas-de-energia') {
        this.getContasEnergia()
      }
      // if (this.$route.hash === '#dimensionamento') {
      //   this.getDadosSistema()
      // }
      if (this.$route.hash === '#atividades') {
        this.getTarefas()
      }
      if (this.$route.hash === '#anexos') {
        this.getAnexos()
      }
      if (this.$route.hash === '#propostas-comerciais') {
        this.getPropostasComerciais()
      }
    },
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.border_table_dark {
  border: 1px $graydark solid;
  &_right {
    border-right: 1px $graydark solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
  &_bottom {
    border-bottom: 1px $graydark solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
}
.border_table {
  border: 1px $graywhite solid;
  &_right {
    border-right: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
  &_bottom {
    border-bottom: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
}
.fit-content {
  width: fit-content;
}
>>> .click_row {
  tr {
    cursor: pointer;
  }
}
>>> .mh_desc {
  textarea {
    min-height: 210px;
  }
}
.btn_personalizado {
  height: 35px!important;
  padding: 0px!important;
  width: 35px!important;
}
.logotipo {
  margin: 5px 5px 5px 0px;
  max-height: 100px;
  max-width: 100px;
}

.proposta_chip {
  width: 100px;
  justify-content: center;
}
.proposta_data_validade {
  cursor: pointer;
}

.v-badge__badge {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/Interna.vue